// // import React, { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Button,
// //   FormControl,
// //   Grid,
// //   Link,
// //   TextField,
// //   Typography,
// // } from "@mui/material";
// // import { Formik, Field, Form, FormikHelpers } from "formik";
// // import * as Yup from "yup";
// // import { AxiosError } from "axios";
// // import camera from "../../../src/assests/images/camera.svg";
// // import archery from "../../../src/assests/images/archery.svg";
// // import AddBonus from "../../components/ReTask/AddBonus";
// // import Dropdowntext from "../../components/ReTask/Dropdowntext";
// // import arrowleft from "../../../src/assests/images/arrow-red.svg";
// // import CreateType from "../../components/ReTask/CreateType";
// // import { getToken } from "../../utils/utils";
// // import { createtask, duplicatetask, edittasks, fetchTaskDetails } from "./api";
// // import TargetQuestions from "../../components/TaskTabContents/TargetQuestions";
// // import EducationalQuestions from "../../components/TaskTabContents/EducationalQuestions";
// // import Plus from "../../../src/assests/images/add.svg";
// // import pdf from "../../../src/assests/images/dicons.svg";
// // import AvailbiltyQuestions from "../../components/TaskTabContents/AvailbiltyQuestions";
// // import marker from "../../../src/assests/images/marker_black.svg";
// // import { useTaskContext } from "../../components/store/AlltasksContext";
// // import ReportDropdown from "../reports/Reportdropdown";
// // import MultiReportDropdown from "../reports/multireportdropdown";
// // import { getdropdowncities } from "../tasks-assigning/api";
// // import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
// // import { useAlert } from "../AlertContext/AlertContext";

// // interface Values {
// //   duration: string;
// //   firstName: string;
// //   points: string;
// //   firstName_hi: string;
// // }

// // interface Option {
// //   value: string;
// //   label: string;
// // }


// // const validationSchema = Yup.object({
// //   // firstName: Yup.string()
// //   //   .required('First Name is required')
// //   //   .min(2, 'First Name must be at least 2 characters'),
// //   // points: Yup.string()
// //   //   .required('Points is required')
// //   //   .min(3, 'Minimum of 3 points required'),

// // });

// // const formValidationfordropdown = Yup.object({
// //   // duration: Yup.string()
// //   //   .required('Select your duration')
// //   //   .min(2, 'Select your duration'),
// // });

// // const handleSubmitfordropdown = (values: Record<string, string>) => { };
// // interface CheckboxItem {
// //   id: number;
// //   value: string;
// //   value_hi: string; // Added value_hi field
// //   checked: boolean;
// //   idid: number;
// //   smallimage: string;
// //   bigimage: string;
// // }

// // interface SectionData {
// //   id: number;
// //   initialName: string;
// //   placeholder: string;
// //   markerImage: string;
// //   typographyText: string;
// //   textValue: string;
// //   mainplaceholder: string;
// //   noOfAttampt: string;
// //   selectValue: string;
// //   dropdownOptions: { id: number; label: string; value: string }[];
// //   instructions: { id: number; value: string }[];
// //   Multiples: { id: number; value: string; checkvalue: string }[];
// //   Checkboxes: { id: number; value: string; checked: boolean }[];
// //   rating: { initialStars: number; maxStarsOptions: number[] };
// // }

// // interface InstructionItem {
// //   id: number;
// //   value: string;
// //   image: string;
// // }

// // const translations = {
// //   en: {
// //     currLang: "en",
// //     taskName: "Task Name",
// //     taskDiscriptions: "Task Description",
// //     // taskDuration: "Task Duration",
// //     points: "Total Points",
// //     enterTaskName: "Enter Task Name",
// //     enterDiscrition: "Enter Task Description",

// //     enterPoints: "Enter Points",
// //     save: "Save",
// //     next: "Next",
// //     back: "Back",
// //     preview: "Preview",
// //     saveDraft: "Save Draft",
// //     //AddBonus
// //     addBonusPoints: "Add Bonus Points",
// //     removeBonusPoints: "Remove Bonus Points",
// //     addDetailBonusPoints: "Add Details Of Bonus Points",
// //     bonusPoints: "Bonus Points*",
// //     bonusduration: "Bonus Duration*",
// //     //Availbilty Questions
// //     imgageGifVideo: "Image/Gif/Video",
// //     uploadImage: "Upload Image",
// //     pageLabel: " Page 1",
// //     uploadText: "Drag & Drop your Image or video /Gif here or Choose file",
// //     uploadSize: "PNG, JPG, GIF, SVG (Max 5 MB), video (Max 10 MB)",
// //     addMore: " + Add More",
// //     instruction: "Instruction",
// //     addInstruction: "Add Instruction",
// //     //Questions
// //     option: "Option",
// //     //questionPoint: "Write your Question Points here",
// //     questionPoint: "Points",
// //     writeHintCorrectOption: "Write a hint for the correct option",
// //     addOptions: "Add Options",
// //     selectCorrectOptionHint: "Select the option for the answer",
// //     taskType: "Task Type",
// //     selectTasktype: "Select tasks type to build the task",
// //     questionsTab: "questions",
// //     notes: "Notes",
// //     availabilityTask: "Availability Task",
// //     educationalTask: "Educational task",
// //     serveyTask: "Survey Task",
// //     feedbackTask: "Feedback Task",
// //     dotcodescanning: "Dotcode Scanning Task",
// //     Irtask: "Image Capture Task",
// //     targetTask: "Target task",
// //     english: "English",
// //     hindi: "Hindi",
// //     // marathi: "Marathi",
// //     days: "Days",
// //     weeks: "Weeks",
// //     selectLocation: "Select Location",
// //     selecttype: "Select Type",
// //     //Dropdown for Dotcode scanner
// //     educationalTaskDrop: "Availability Task",
// //     targetTaskDrop: "Ranging Task",
// //     feedbackTaskDrop: "Stock weight Task",
// //     dotcodeScanningDrop: "Micro Targeting Task",
// //     imageCaptureDrop: "Image Capture Task",
// //     selectoption: "Select an option",
// //     completedType: "Completion Type",
// //     ApprovalType:"Approval Type",
// //     noOfAttampt: "Number of Attempts",
// //   },
// //   hi: {
// //     currLang: "hi",
// //     taskName: "कार्य का नाम",
// //     taskDiscriptions: "कार्य विवरण",
// //     // taskDuration: "कार्य अवधि",
// //     points: "कुल अंक",
// //     enterTaskName: "कार्य का नाम दर्ज करें",
// //     enterDiscrition: "कार्य विवरण दर्ज करें",

// //     enterPoints: "अंक दर्ज करें",
// //     save: "सहेजें",
// //     next: "अगला",
// //     back: "पीछे",
// //     preview: "पूर्वावलोकन",
// //     saveDraft: "ड्राफ्ट सहेजें",
// //     //AddBonus
// //     addBonusPoints: "बोनस अंक जोड़ें",
// //     removeBonusPoints: "बोनस अंक हटाएँ",
// //     addDetailBonusPoints: "बोनस अंकों का विवरण जोड़ें",
// //     bonusPoints: "बोनस अंक*",
// //     bonusduration: "बोनस अवधि*",
// //     //Availbilty Questions
// //     imgageGifVideo: "छवि/जीआईएफ/वीडियो",
// //     uploadImage: "तस्विर अपलोड करना",
// //     pageLabel: "गुगल भाषांतर",
// //     uploadText: "अपनी छवि/जीआईएफ यहाँ खींचें और छोड़ें या फ़ाइल चुनें",
// //     uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
// //     addMore: "+ अधिक जोड़ें",
// //     instruction: "अनुदेश",
// //     addInstruction: "अनुदेश जोड़ें",
// //     //Questions
// //     option: "विकल्प",
// //     questionPoint: "अंक",
// //     writeHintCorrectOption: "सही विकल्प के लिए संकेत लिखें",
// //     addOptions: "विकल्प",
// //     selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
// //     taskType: "कार्य प्रकार",
// //     selectTasktype: "कार्य बनाने के लिए कार्य प्रकार चुनें",
// //     questionsTab: "प्रश्न",
// //     notes: "नोट्स",
// //     availabilityTask: "उपलब्धता कार्य",
// //     educationalTask: "शैक्षिक कार्य",
// //     serveyTask: "सर्वेक्षण",
// //     feedbackTask: "प्रतिक्रिया",
// //     dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
// //     Irtask: "छवि कैप्चर कार्य",
// //     // targetTask: "उपलब्धता कार्य",
// //     english: "अंग्रेज़ी",
// //     hindi: "हिंदी",
// //     // marathi: "मराठी",
// //     days: "दिन",
// //     weeks: "सप्ताह",
// //     selectLocation: "स्थान चुनें",
// //     selecttype: "पूर्ण प्रकार",
// //     //Drop down
// //     educationalTaskDrop: "उपलब्धता कार्य",
// //     targetTaskDrop: "रेंजिंग कार्य",
// //     feedbackTaskDrop: "स्टॉक वजन कार्य",
// //     dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
// //     imageCaptureDrop: "छवि कैप्चर कार्य",
// //     selectoption: "एक विकल्प चुनें",
// //     completedType: "पूर्ण प्रकार",
// //     ApprovalType:"अनुमोदन प्रकार",
    
// //     noOfAttampt: "प्रयासों की संख्या",
// //   },
// //   mr: {
// //     currLang: "mr",
// //     taskName: "कार्याचे नाव",
// //     taskDiscriptions: "कार्य अवधि",

// //     points: "कुल अंक",
// //     enterTaskName: "कार्याचे नाव प्रविष्ट करा",
// //     enterDiscrition: "कार्य विवरण दर्ज करें",
// //     enterPoints: "गुण प्रविष्ट करा",
// //     save: "जतन करा",
// //     next: "पुढे",
// //     back: "मागे",
// //     preview: "पूर्वावलोकन",
// //     saveDraft: "ड्राफ्ट जतन करा",
// //     //AddBonus
// //     addBonusPoints: "बोनस गुण जोडा",
// //     removeBonusPoints: "बोनस गुण काढा",
// //     addDetailBonusPoints: "बोनस गुणांचा तपशील जोडा",
// //     bonusPoints: "बोनस गुण*",
// //     bonusduration: "बोनस कालावधी*",
// //     //Availbilty Questions
// //     imgageGifVideo: "प्रतिमा/जीआयएफ/व्हिडिओ",
// //     uploadImage: " पृष्ठ 1",
// //     pageLabel: " पृष्ठ 1",
// //     uploadText: "आपली प्रतिमा/जीआयएफ इथे ओढा आणि सोडा किंवा फाईल निवडा",
// //     uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
// //     addMore: "+ अधिक जोडा",
// //     instruction: "सूचना",
// //     addInstruction: "सूचना जोडा",
// //     //Questions
// //     initialName: "",
// //     placeholder: " string",
// //     typographyText: "string",
// //     option: "पर्याय",
// //     questionPoint: "अंक",
// //     writeHintCorrectOption: "योग्य पर्यायासाठी सूचना लिहा",
// //     addOptions: "पर्याय",
// //     selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
// //     taskType: "कार्य प्रकार",
// //     selectTasktype: "कार्य तयार करण्यासाठी कार्य प्रकार निवडा",
// //     questionsTab: "प्रश्न",
// //     notes: "नोंद",
// //     availabilityTask: "उपलब्धता कार्य",
// //     educationalTask: "शैक्षणिक कार्य",
// //     serveyTask: "सर्वेक्षण",
// //     feedbackTask: "अभिप्राय",
// //     dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
// //     Irtask: "छवि कैप्चर कार्य",
// //     // targetTask: "उपलब्धता कार्य",
// //     english: "इंग्रजी",
// //     hindi: "हिंदी",
// //     // marathi: "मराठी",
// //     days: "दिवस",
// //     weeks: "आठवडे",
// //     selectLocation: "स्थान निवडा",
// //     selecttype: "प्रकार चुनें",
// //     //Drop down
// //     educationalTaskDrop: "उपलब्धता कार्य",
// //     targetTaskDrop: "रेंजिंग कार्य",
// //     feedbackTaskDrop: "स्टॉक वजन कार्य",
// //     dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
// //     imageCaptureDrop: "छवि कैप्चर कार्य",
// //     selectoption: "एक विकल्प चुनें",
// //     completedType: "पूर्ण प्रकार",
// //     ApprovalType:"अनुमोदन प्रकार",

// //     noOfAttampt: "प्रयासों की संख्या",
// //   },
// // };

// // function CreateTask() {
// //   const token = getToken();
// //   const {
// //     setActiveStep,
// //     activeStep,
// //     correctHintArray,
   
// //     correctHintHiArray,
// //     textValueData,
// //     textValueHiData,
// //     instructionImageMap,
// //     setInstructionImageMap,
// //     valueHiArray,
// //     valueArray,
// //     test22Value,
// //     step1data,
// //     step1data2,
// //     checkboxItems,
// //     selectedItems,
// //     textValueData44,
// //     selectedOption1
// //   } = useTaskContext();

// //   // const [activeStep, setActiveStep] = useState(1);

// //   const languageMap: Record<number, "en" | "hi" | "mr"> = {
// //     1: "en",
// //     2: "hi",
// //     3: "mr",
// //   };

// //   const handleNextStep = (param = "en") => {
// //     if (activeStep < steps.length) {
// //       setActiveStep(activeStep + 1);
// //     }
// //     console.log(param, "paramparamparamparamparamparamparam");
// //     setCurrentLang(languageMap[activeStep + 1]);
// //   };
// //   const handleBackStep = (param?: string) => {
// //     if (activeStep > 1) {
// //       const prevStep = activeStep - 1;
// //       setActiveStep(prevStep);
// //       setCurrentLang(languageMap[prevStep]);

// //       // Update currentData with selectedmcq for selectValue
// //       setCurrentData(
// //         currentData.map((item: any) => ({
// //           ...item,
// //           selectValue: selectedmcq,
// //         }))
// //       );
// //       console.log(currentData, "currentData444444")
// //       console.log(param || languageMap[prevStep], "paramparamparam");
// //     }
// //   };
// //   console.log(step1data2, "pppp9999999989")
// //   const { id } = useParams();
// //     const { duplicate_id } = useParams();
// //     console.log(duplicate_id, "duplicate_idduplicate_id",id,"ididididid")
// //   const currentLang = translations[languageMap[activeStep]];
// //   const steps = [
// //     { id: 1, name: currentLang.english },
// //     { id: 2, name: currentLang.hindi },
// //     // { id: 3, name: currentLang.marathi },
// //   ];

// //   const getAvailabilityContent = () => (
// //     <AvailbiltyQuestions lang={currentLang} />
// //   );
// //   const getEducationalContent = () => (
// //     <EducationalQuestions lang={currentLang} />
// //   );
// //   const getTargetContent = () => <TargetQuestions lang={currentLang} />;
// //   useEffect(() => {
// //     setTabsData([
// //       // {
// //       //   label: "Availability Task",
// //       //   value: "1",
// //       //   content: getAvailabilityContent(),
// //       //   isEditable: false,
// //       //   name: currentLang.availabilityTask,
// //       //   name_hi: "उपलब्धता कार्य",
// //       //   image: pdf,
// //       //   isActive: true,
// //       // },
// //       {
// //         label: "Item Two",
// //         value: "2",
// //         content: getEducationalContent(),
// //         isEditable: false,
// //         name: currentLang.educationalTask,
// //         name_hi: "शैक्षिक कार्य",
// //         image: camera,
// //         isActive: false,
// //       },

// //       {
// //         label: "Item Three",
// //         value: "3",
// //         content: getEducationalContent(),
// //         isEditable: false,
// //         name: currentLang.serveyTask,
// //         name_hi: "सर्वेक्षण",
// //         image: camera,
// //         isActive: false,
// //       },
// //       {
// //         label: "Item Three",
// //         value: "4",
// //         content: getEducationalContent(),
// //         isEditable: false,
// //         name: currentLang.feedbackTask,
// //         name_hi: "प्रतिक्रिया",
// //         image: camera,
// //         isActive: false,
// //       },

// //       {
// //         label: "Item Six",
// //         value: "6",
// //         content: getEducationalContent(),
// //         isEditable: false,
// //         name: currentLang.dotcodescanning,
// //         name_hi: "डॉटकोड स्कैनिंग कार्य",
// //         image: camera,
// //         isActive: false,
// //       },
// //       {
// //         label: "Item Seven",
// //         value: "7",
// //         content: getEducationalContent(),
// //         isEditable: false,
// //         name: currentLang.Irtask,
// //         name_hi: "छवि कैप्चर कार्य",
// //         image: camera,
// //         isActive: false,
// //       },

// //       // {
// //       //   label: "Item Three",
// //       //   value: "3",
// //       //   content: getTargetContent(),
// //       //   isEditable: false,
// //       //   name: currentLang.targetTask,
// //       //   image: archery,
// //       //   isActive: false,
// //       // },
// //     ]);
// //   }, [currentLang]);

// //   const [dropdowncities, setdropdowncities] = useState<any[]>([]);

// //   useEffect(() => {
// //     const fetchdropdowncities = async () => {
// //       try {
// //         const response = await getdropdowncities();
// //         const cities = response.data.data || [];
// //         setdropdowncities(
// //           cities.map((city: string) => ({ value: city, label: city }))
// //         );
// //       } catch (error) {
// //         console.error("Error fetching cities:", error);
// //       }
// //     };

// //     fetchdropdowncities();
// //   }, []);

// //   const [tabsData, setTabsData] = useState([
// //     {
// //       label: "Item OneE",
// //       value: "1",
// //       content: <AvailbiltyQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Availability Task",
// //       name_hi: "उपलब्धता कार्य",
// //       image: pdf,
// //       isActive: true,
// //     },
// //     {
// //       label: "Item Two",
// //       value: "2",
// //       content: <EducationalQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Educational task",
// //       name_hi: "शैक्षिक कार्य",
// //       image: camera,
// //       isActive: false,
// //     },
// //     {
// //       label: "Item Three",
// //       value: "3",
// //       content: <TargetQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Target taskfffffff",
// //       name_hi: "",
// //       image: archery,
// //       isActive: false,
// //     },
// //     {
// //       label: "Item Four",
// //       value: "4",
// //       content: <EducationalQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Servey Task",
// //       name_hi: "",
// //       image: archery,
// //       isActive: false,
// //     },
// //     {
// //       label: "Item Five",
// //       value: "5",
// //       content: <EducationalQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "FeedBack Task",
// //       name_hi: "",
// //       image: archery,
// //       isActive: false,
// //     },
// //     {
// //       label: "Item Six",
// //       value: "6",
// //       content: <EducationalQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Dotcodescaning Task",
// //       name_hi: "",
// //       image: archery,
// //       isActive: false,
// //     },
// //     {
// //       label: "Item Seven",
// //       value: "7",
// //       content: <EducationalQuestions lang={currentLang} />,
// //       isEditable: false,
// //       name: "Image Capture Task",
// //       name_hi: "",
// //       image: archery,
// //       isActive: false,
// //     },
// //   ]);

// //   // const [Tabname, setTabname] = useState("");
// //   const [value, setValue] = useState<string>("");
// //   const [iconimagggg, seticonimagggg] = useState("cccccccccc");
// //   const [bouncedurationValue, setbounceDurationValue] = useState<string>("");
// //   const [bouncedurationUnit, sebouncetDurationUnit] = useState<string>("");
// //   const [bonusPoints, setBonusPoints] = useState("");
// //   const [name, setName] = useState<string>("");
// //   const [durationValue, setDurationValue] = useState<string>("");
// //   const [durationValuepoints, setDurationValuepoints] = useState<string>("");
// //   const [durationValuetaskname, setDurationValuetasakname] = useState<string>("");
// //   const [durationValuetaskname22, setDurationValuetasakname22] = useState<string>("");
// //   const [Discriptionsdata, setDiscriptions] = useState<string>("");
// //   const [Discriptionsdatahi, setDiscriptionshi] = useState<string>("");
// //   const [durationUnit, setDurationUnit] = useState<string>("");
// //   const [taskName, setTaskName] = useState<string>("");
// //   const navigate = useNavigate()
// //   const {
// //     sectionsData,
// //     setSectionsData,
// //     fileName,
// //     educationalData,
// //     seteducationalData,
// //     Tabname,
// //     setTabname,
// //     instructions33,
// //     longDescriptions,
// //     longDescriptionsHi,
// //     imagesdata3,
// //     setfinalll,
// //     finalll,
// //     imagesdata,
// //     imagesdata1,
// //     currentData,
// //     currentLang: contextLang,
// //     setCurrentLang,
// //     uploadedImages, setUploadedImages,
// //     setallinone, allinone

// //   } = useTaskContext();

// //   useEffect(() => {
// //     console.log("Create Data:", sectionsData);
// //   }, [currentLang]);

// //   const { showAlert } = useAlert();
// //   console.log(tabsData, "55555555544444444444444444444");
// //   console.log(instructions33, "ccccccccccccxxxxxxxxxxxx");
// //   console.log(
// //     tabsData
// //       .filter((item) => item.isEditable === true)
// //       .map((item) => item.name)
// //       .join(","),
// //     "tabsDatassssssssssssss"
// //   );
// //   console.log(Tabname, "Tabnameddddddd");
// //   console.log(finalll, "fileNamessssssssseeeeeeeeeee");
// //   const options = [
// //     { value: "", label: "All Location" },
// //     ...dropdowncities.map((item) => ({
// //       value: item.value,
// //       label: item.label,
// //     })),
// //   ];

// //   const options1: Option[] = [
// //     { label: "Completed", value: "1" },
// //     { label: "Partially", value: "2" },
// //   ];
// // const options2:Option[]=[
// //      { label: "Required", value: "1" },
// //     { label: "Not Required", value: "2" },
// //   ];

 
// //   const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
// //   const [selectedOption, setSelectedOption] = useState<string>("");
// // const [selectApprovalType,setselectApprovalType]=useState<string>("");  const [faltsubmit, setfaltsubmit] = useState(false);

// //   const handleDropdownChange1 = (selected: Option | null) => {
// //     const newValue = selected ? selected.value : "";
// //     setSelectedOption(newValue);
// //   };
// //   const handleDropdownChange2 = (selected: Option | null) => {
// //     const newValue = selected ? selected.value : "";
// //     setSelectedOption(newValue);
// //   };
// //   const handleDropdownChange = (
// //     selected: { value: string; label: string }[] | null
// //   ) => {
// //     const newValues = selected ? selected.map((opt) => opt.value) : [];
// //     setSelectedOptions(newValues);
// //   };
// //   const enableSaveButton = activeStep >= 2;
// //   console.log(selectedOptions, "selectedOptions6666666666666");
// //   console.log(imagesdata, "fileNameimagesdataimagesdata");
// //   console.log(sectionsData, "sectionsDatassssssvvvv8888888888888");
// //   console.log(activeStep, "888888888888888");
// //   console.log(instructionImageMap, "522instructionImageMap2999666");
// //   console.log(valueHiArray, "valueHiArraytttt", valueArray);
// //   console.log(test22Value, "test22Valuennnnnnnn");
// //   console.log(instructions33, "instructions33yyyyyyyy");
// //   console.log(step1data, "uploadedImagesdddddddddd222", step1data2, "step1data2step1data2")
// //   console.log(JSON.stringify(step1data, null, 2), "Response data");
// //   console.log(currentData, "currentDatassssssssooooo")
// //   //  useEffect(() => {
// //   //   if (!id) return; // ✅ only run if id exists

// //   //   const fetchData = async () => {
// //   //     try {
// //   //       const response = await fetchTaskDetails(String(id), token);
// //   //       console.log(response.data.data, "Task Details");
// //   //     } catch (error) {
// //   //       console.error("Error fetching task details:", error);
// //   //     }
// //   //   };

// //   //   fetchData();
// //   // }, [id, token]); // include token if it can change
// //   const {
// //     setimagesdata1,
// //     setimagesdata,

// //     setTextValueData,
// //     setTextValueHiData,
// //     setTest22Value,
// //     setValueArray,
// //     setCorrectHintArray,
// //     setCorrectHintHiArray,
// //     setValueHiArray,
// //     setstep1data2,
// //     setFiles,
// //     files,
// //     setInstructions,
// //     instructions33default, setInstructionsdefault,
// //     setCurrentData,
// //     selectedmcq,
// //     currentlength,
// //     setcurrentlength,
// //     setdefaultvalues,
// //     setdefaultipostermages,
// //     setdefaulttaskiconimages,
// //     defaulttaskiconimages,
// //     setSelectedOption1,setTextValueData44,
// //     textValueDatadefault, setTextValueDatadefault,
// //     textValueDatadefaulthindi, setTextValueDatadefaulthindi,
// //     setstep1data2default,
// //     setCheckboxItems,
// //     setstep1data2defaultchekbox,
// //     allhintsteps, setallhitssteps,
// //     selectedmcq22,
// //  setSelectedmcq22,

// //   } = useTaskContext();
// //   console.log(textValueData, "textValueDatatextValueData")
// //   console.log(id, "Dddddddddddd")
// //   console.log(Tabname, "Tabname77888")
// //   console.log(selectedmcq, "selectssedmcqss",selectedmcq22, "selectedmcq22selectedmcq22")
// // const [selectedmcq221, setSelectedmcq221] = useState<Record<number, string>>({});
// // console.log(checkboxItems, "checkboxItems8999966666")
// //   useEffect(() => {
// //    if (!id && !duplicate_id) return;// Only run if id exists

// //     const fetchData = async () => {
// //       try {
// //         const defaultSmallImage = process.env.PUBLIC_URL + "/assets/stepIcon5.svg";
// //    const taskIdToFetch = id ? String(id) : duplicate_id ?? "";
// // const response: any = await fetchTaskDetails(taskIdToFetch, token);
// //         const taskData = response.data.data.task;
// //         setdefaultvalues(taskData)
// //         setdefaultipostermages([taskData.intro_poster])
// //         setdefaulttaskiconimages([taskData.task_icon])
       
// // if (taskData.completed_type === "completed") {
// //   setSelectedOption("1");
// // } else if (taskData.completed_type === "partially") {
// //   setSelectedOption("2");
// // }

// // if (taskData.approval_type === "Required") {
// //   setSelectedOption("1");
// // } else if (taskData.approval_type === "Not Required") {
// //   setSelectedOption("2");
// // }


// // console.log(defaulttaskiconimages, "defaulttaskiconimagesdefaulttaskiconimages")
// //        const instructionData = response.data.data.taskinstructions.map((item: { id: any; task_instruction: any; task_instruction_hi: any; task_instruction_img: any; task_instruction_img_big: any; task_instruction_vidio_big: any; }) => ({
// //   id: item.id,
// //   value: item.task_instruction,
// //   value_hi: item.task_instruction_hi || "",
// //   smallimage: item.task_instruction_img || defaultSmallImage,
// //   bigimage: item.task_instruction_img_big || item.task_instruction_vidio_big || defaultSmallImage,
// // }));

// //         console.log(taskData.task_type, "fggggggggggggg")
// //         if (taskData.subtasks.length > 0) {
// //           setcurrentlength(taskData.subtasks.length)
// //         }

// //         console.log(taskData.subtasks.length, "taskData.subtasksssss")
// //         setallinone(taskData.subtasks)
// //      const hitssteps = taskData.subtasks.flatMap((item: { hint: { steps: any; }; question_no: number }) =>
// //   (item.hint?.steps || []).map((step: { step_number: any; step_text_en: any; step_text_hi: any; step_icon: any; }) => ({
// //     questions_id: item.question_no, // <-- comma added
// //     step_number: step.step_number,
// //     step_text_en: step.step_text_en,
// //     step_text_hi: step.step_text_hi,
// //     step_icon: step.step_icon
// //   }))
// // );

// // setallhitssteps(hitssteps);


// //         // Prefill task instructions
// //    setDiscriptions(taskData.task_discriptions_en)
// //    setDiscriptionshi(taskData.task_discriptions_hi)
       
// //         setInstructionsdefault(instructionData);
// // console.log(instructions33, "instructions33instructions33")
// //         // Prefill task-level data
// //         setDurationValuetasakname(taskData.task || "");
// //         setDurationValuetasakname22(taskData.task_title_hi  || "");
// //         setDurationValuepoints(taskData.credit_points?.toString() || "");
// //         setBonusPoints(taskData.bonus_point?.toString() || "");
// //         console.log(response.data.data.task_subtasks.subtask_type_en, "taskData.task_subtaskssssss")

// //         const subtaskMap: Record<string, string> = {
// //   "Availability Task": "Availability",
// //   "Ranging Task": "Ranging",
// //   "Micro Targeting Task": "Micro Targeting",
// // };

// // // assert that the value is a string
// // setSelectedOption1(subtaskMap[response.data.data.task_subtasks.subtask_type_en as string] || "");
// // //  setSelectedOption1(response.data.data.task_subtasks.subtask_type_en)
// //         if (taskData.duration) {
// //           const [value, unit] = taskData.duration.split(" ");
// //           setDurationValue(value || "");
// //           setDurationUnit(unit || "");
// //         }

// //         if (taskData.location) {
// //           setSelectedOptions(taskData.location.split(","));
// //         }
// // console.log(taskData.task_type, "taskData.task_typess")
// //         setTabname(taskData.task_type === "Educational" ? "Educational task" :taskData.task_type === "Survey" ? "Survey Task":taskData.task_type === "Feedback" ? "Feedback Task":taskData.task_type === "Dotcode Scanning Task" ? "Dotcode Scanning Task":taskData.task_type === "Image Capture Task" ? "Image Capture Task": taskData.task_type);




// //      const updated = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
// //   acc[item.question_no] = String(item.points ?? "");
// //   return acc;
// // }, {});

// // setTest22Value(updated);
       
// //      const updated1 = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
// //   acc[item.question_no] = String(item.sample_picture ?? "");
// //   return acc;
// // }, {});


// // setUploadedImages(updated1)
// // taskData.subtasks.forEach((item: any) => {
// //   setTextValueData44(prev => [
// //     ...prev,
// //     { id: item.question_no, value: String(item.max_no_of_attempts ?? "") }
// //   ]);
// // });


// // const mappedStep1Data2 = taskData.subtasks.map((item: any) => ({
// //   id: item.question_no,
// //   Multiples: item.options.map((option: any, index: number) => ({
// //     id: index + 1, // 1-based index for Multiples
// //     value: option.option_value_en || "", // option value
// //     value_hi: option.option_value_hi || "", // same as value or from another field if you have Hindi
// //     checkvalue: `check${index + 1}`, // or option.correct_option if you want
// //     smallimage: option.option_small_img || "",
// //     bigimage: option.option_big_img || "",
// //     mainid: item.question_no,
// //     ismatch: option.correct_option === "1" // true if correct_option === "1"
// //   }))
// // }));

// // setstep1data2default(mappedStep1Data2);


// // const newValues: any[] = [];

// // taskData.subtasks.forEach((item: any, subIndex: number) => {
// //   item.hint.steps.forEach((option: any, optIndex: number) => {
// //     newValues.push({
// //       mainid: item.question_no,
// //       index: optIndex + 1,
// //       value: option.step_text_en || "",
// //     });
// //   });
// // });

// // setValueArray(newValues);





// // // 2. When looping, type prev explicitly
// // taskData.subtasks.forEach((item: any) => {
// //   setSelectedmcq22((prev: Record<number, string>): Record<number, string> => ({
// //     ...prev,
// //     [item.question_no]: item.main_questions_type || "",
// //   }));
// // });


// // console.log(selectedmcq22, "ksssssssssssssssssskkkkkkkkkk");









// // const newValues1: any[] = [];

// // taskData.subtasks.forEach((item: any, subIndex: number) => {
// //   item.hint.steps.forEach((option: any, optIndex: number) => {
// //     newValues1.push({
// //       mainid: item.question_no,
// //       index: optIndex + 1,
// //       value: option.step_text_hi || "",
// //     });
// //   });
// // });

// // setValueHiArray(newValues1);


// // const newValuesiamges: any[] = [];

// // taskData.subtasks.forEach((item: any) => {
// //   item.hint.steps.forEach((option: any, optIndex: number) => {
// //     newValuesiamges.push({
// //       mainId: item.question_no,
// //       instructionId: optIndex + 1,
// //       image: option.step_icon || "",
// //     });
// //   });
// // });

// // setInstructionImageMap(newValuesiamges);


// // const defaultCheckboxItems = taskData.subtasks.reduce(
// //   (acc: { [key: number]: CheckboxItem[] }, item: any) => {
// //     if (item.main_questions_type === 'checkbox') {
// //       acc[item.question_no] = item.options.map((option: any, index: number) => ({
// //         id: index + 1,
// //         value: option.option_value_en || "",
// //         value_hi: option.option_value_hi || "",
// //         checked: option.correct_option === "1",
// //         idid: item.question_no,
// //         smallimage: option.option_small_img || "",
// //         bigimage: option.option_big_img || "",
// //       }));
// //     } else {
// //       // acc[item.question_no] = []; // optional: initialize empty array for non-checkbox questions
// //     }
// //     return acc;
// //   },
// //   {}
// // );

// // setCheckboxItems(defaultCheckboxItems);



// // const daa = taskData.subtasks.reduce((acc: { id: number; index: number; value: string }[], item: any, i: number) => {
// //   acc.push({
// //     id: item.question_no,
// //     index: i, // incrementing index
// //     value: item.hint?.content_type_en || ""
// //   });
// //   return acc;
// // }, []);

// // setCorrectHintArray(daa);


// // const daa1 = taskData.subtasks.reduce((acc: { id: number; index: number; value: string }[], item: any, i: number) => {
// //   acc.push({
// //     id: item.question_no,
// //     index: i, // incrementing index
// //     value: item.hint?.content_type_hi || ""
// //   });
// //   return acc;
// // }, []);

// // setCorrectHintHiArray(daa1);


// // // setstep1data2defaultchekbox(mappedStep1Data2)

// // // setCheckboxItems(mappedStep1Data2)
// // // const updatedTextValueData = taskData.subtasks.map((item: any) => ({
// // //   id: item.question_no,
// // //   value: String(item.question ?? "")
// // // }));
// // // setTextValueData(updatedTextValueData);

// // const initialTextValueData44 = taskData.subtasks.map((item: any) => ({
// //   id: item.question_no,
// //   value: String(item.question ?? "")
// // }));


// // // Set state once
// // setTextValueDatadefault(initialTextValueData44);



// // const initialTextValueData44hindi = taskData.subtasks.map((item: any) => ({
// //   id: item.question_no,
// //   value: String(item.question_hi ?? "")
// // }));

// // setTextValueDatadefaulthindi(initialTextValueData44hindi);

// // console.log(initialTextValueData44,"pppdspsps99999999",textValueDatadefault, "6666666699999999",);
// // console.log(taskData.subtasks.map((item: { question: any; })=>item.question))


// // taskData.subtasks.forEach((item: any) => {
// //   setTextValueHiData(prev => [
// //     ...prev,
// //     { id: item.question_no, value: String(item.question_hi ?? "") }
// //   ]);
// // });

// //       //    Tabname === "Educational task" ||
// //       // Tabname === "शैक्षिक कार्य" ||
// //       // Tabname === "शैक्षणिक कार्य" ||
// //       // Tabname === "Survey Task" ||
// //       // Tabname === "सर्वेक्षण" ||
// //       // Tabname === "Feedback Task" ||
// //       // Tabname === "प्रतिक्रिया" ||
// //       // Tabname=== "Image Capture Task" ||
// //       // Tabname=== "छवि कैप्चर कार्य" ||
// //       // Tabname === "Dotcode Scanning Task" ||
// //       // Tabname === "डॉटकोड स्कैनिंग कार्य"


// //         // setValue(
// //         //   taskData.task_type === "Educational" || taskData.task_type === "शैक्षिक"
// //         //     ? "2"
// //         //     : taskData.task_type === "Survey Task" || taskData.task_type === "सर्वेक्षण"?'3'
// //         //      : taskData.task_type === "Feedback Task" || taskData.task_type === "प्रतिक्रिया"?'4'
// //         // );

// //         setValue(
// //           taskData.task_type === "Educational" || taskData.task_type === "शैक्षिक"
// //             ? "2"
// //             : taskData.task_type === "Survey Task" || taskData.task_type === "सर्वेक्षण" || taskData.task_type === "Survey"
// //               ? "3"
// //               : taskData.task_type === "Feedback Task" || taskData.task_type === "प्रतिक्रिया" || taskData.task_type === "Feedback"
// //                 ? "4"


// //                 : taskData.task_type === "Dotcode Scanning Task" || taskData.task_type ===  "डॉटकोड स्कैनिंग कार्य"

// //                 ? "6"

// //                 : taskData.task_type === "Image Capture Task"
// //                 ? "7"

               
// //                 : ""
// //         );


// //         if (taskData.task_icon) {
// //           seticonimagggg(taskData.task_icon);
// //           setimagesdata1([{ id: 1, images: [taskData.task_icon] }]);
// //         }

// //         // if (taskData.intro_poster) {
// //         //   setimagesdata([{ id: 3, images: [taskData.intro_poster] }]);
// //         //   setFiles([
// //         //     {
// //         //       id: 3,
// //         //       file: {} as File, // Placeholder
// //         //       preview: taskData.intro_poster,
// //         //     },
// //         //   ]);
// //         // }

// //         // Prefill question-related data
// //         const subtasks = taskData.subtasks || [];

// //         // Set textValueData (question_en)
// //         setTextValueData(
// //           subtasks.map((subtask: any) => ({
// //             id: subtask.question_no,
// //             value: subtask.question_en || "",
// //           }))
// //         );

// //         // Set textValueHiData (question_hi)
// //         setTextValueHiData(
// //           subtasks.map((subtask: any) => ({
// //             id: subtask.question_no,
// //             value: subtask.question_hi || "",
// //           }))
// //         );


// //         console.log("Task Details Loaded:", taskData);
// //       } catch (error) {
// //         console.error("Error fetching task details:", error);
// //         showAlert("Failed to load task details", "error");
// //       }
// //     };

// //     fetchData();
// //   }, [
// //     id,
// //     token,

// //     setDurationValuetasakname,
// //     setDurationValuetasakname22,
// //     setDurationValuepoints,
// //     setBonusPoints,
// //     setDurationValue,
// //     setDurationUnit,
// //     setSelectedOptions,
// //     setTabname,
// //     duplicate_id,
// //     setValue,
// //     seticonimagggg,
// //     setSectionsData,
// //     seteducationalData,
// //     setimagesdata,
// //     setimagesdata1,
// //     setFiles,
// //     setInstructions,
// //     setTextValueData,
// //     setTextValueHiData,
// //     setTest22Value,
// //     setUploadedImages,
// //     setCorrectHintArray,
// //     setCorrectHintHiArray,
// //     setValueArray,
// //     setValueHiArray,
// //     setInstructionImageMap,
// //     // setstep1data2,
// //     setCurrentData,
// //   ]);
// //   console.log(currentlength, "currentlengthcurrentlength")
// //   console.log(selectedOptions, "durationValuepointsdurationValuepoints")
// //   console.log(educationalData, "imagesdatassssssssssssss")
// //   console.log(instructions33, "instructions33instructions33")
// //   console.log(correctHintArray, "correctHintArray33333")
// //   console.log(test22Value, "test22Valujjdu8888e")
// //   console.log(currentData, "currentDatapppp999999")
// //   console.log(longDescriptions, imagesdata3, "imagesdata3imagesdata333")
// //   console.log(valueArray, valueHiArray, "pppppppppp4444444")
// //   console.log(Tabname, "Tabnamssssse")
// //   console.log(selectedItems, "selectedItems9999999")
// //   console.log(test22Value, "textValueData44888888888")
// //   console.log(selectedOption1, "selectedOption333333")
// //   console.log(step1data2, "step1data2ssswwwwwww")
// //   const location = useLocation();

// //   const handleSubmitSave = async (
// //     values: Values,
// //     { setSubmitting }: FormikHelpers<Values>
// //   ) => {
// //     setfaltsubmit(true)

// //     console.log(values, "vassslues");
// //     const fields = [durationValue, durationValuetaskname22, durationUnit, durationValuetaskname];

// //     if (fields.every(f => !f)) {
// //       showAlert("error");
// //       setSubmitting(false);
// //       return;
// //     }

// //     if (value === "") {
// //       showAlert("please select one Tab");
// //       setSubmitting(false);
// //       return;
// //     }
// //     // Filter sectionsData to remove empty text values
// //     const filteredSections = sectionsData.filter(
// //       (item) => item.textValue !== "" && item.textValue !== null
// //     );
// //     console.log(filteredSections, "Filtered sectionsData");

// //     const tabNameMapEn: Record<string, string> = {
// //       "Availability Task": "Availability",
// //       "Educational task": "Educational",
// //       "शैक्षिक कार्य": "Educational",
// //       "शैक्षणिक कार्य": "Educational",
// //       "Survey Task": "Survey",
// //       "सर्वेक्षण": "Survey",
// //       "Feedback Task": "Feedback",
// //       "प्रतिक्रिया": "Feedback",
// //     };


// //     const tabNameMapHi: Record<string, string> = {
// //       "Availability Task": "उपलब्धता",
// //       "Educational task": "शैक्षिक",
// //       "शैक्षिक कार्य": "शैक्षिक",
// //       "शैक्षणिक कार्य": "शैक्षिक",
// //       "Survey Task": "सर्वेक्षण",
// //       "सर्वेक्षण": "सर्वेक्षण",
// //       "Feedback Task": "प्रतिक्रिया",
// //       "प्रतिक्रिया": "प्रतिक्रिया",
// //     };

// //     const fallbackNameEn = tabNameMapEn[Tabname] || Tabname;
// //     const fallbackNameHi = tabNameMapHi[Tabname] || "";
// //     let taskMap = {
// //       "Availability": { en: "Availability Task", hi: "उपलब्धता कार्य" },
// //       "Ranging": { en: "Ranging Task", hi: "रेंजिंग कार्य" },
// //       "Stock weight": { en: "Stock weight Task", hi: "स्टॉक भार कार्य" },
// //       "Micro Targeting": { en: "Micro Targeting Task", hi: "सूक्ष्म लक्ष्यीकरण कार्य" }
// //     };

// //     const creattask1 = {
// //       task_id:id?id:'',
// //       task_en: durationValuetaskname || "",
// //       task_hi: activeStep === 2
// //         ? (durationValuetaskname22 === "" ? durationValuetaskname : durationValuetaskname22)
// //         : "",
// //       selectedOption: taskMap[selectedOption1 as keyof typeof taskMap]?.en || "",
// //       selectedOption_hi: taskMap[selectedOption1 as keyof typeof taskMap]?.hi || "",

// //       task_discriptions: Discriptionsdata || "",
// //       task_discriptions_hi: activeStep === 2
// //         ? (Discriptionsdatahi === "" ? Discriptionsdata : Discriptionsdatahi)
// //         : "",
// //       completed_type: selectedOption === "1"
// //         ? "completed"
// //         : selectedOption === "2"
// //           ? "partially"
// //           : "",
// //           approval_type:
// //           selectApprovalType === "1"
// //         ? "Required"
// //         : selectApprovalType === "2"
// //           ? "Not Required"
// //           : "",

// //       credit_points: durationValuepoints,
// //       duration: `${durationValue || ""} ${durationUnit || ""}`.trim(),
// //       require_task_approval: false,
// //       bonus_point: bonusPoints,
// //       bonus_duration: `${bouncedurationValue || ""} ${bouncedurationUnit || ""
// //         }`.trim(),
// //       location: selectedOptions.length ? selectedOptions.join(",") : "",
// //       task_type_hi:
// //         activeStep === 2
// //           ? (
// //             tabsData
// //               .filter((item) => item.isEditable === true)
// //               .map((item) => item.name_hi)
// //               .join(",") || fallbackNameHi
// //           )
// //           : "",
// //       task_type_en:
// //         tabsData
// //           .filter((item) => item.isEditable === true)
// //           .map((item) => item.name)
// //           .join(",") || fallbackNameEn,
// //       task_icon: imagesdata1
// //         .filter((item) => item.images.length > 0)
// //         .map((item) => item.images.join(","))
// //         .join(","),
// //       intro_poster: imagesdata
// //         .filter((item) => item.images.length > 0)
// //         .flatMap((item) => item.images),

// //       task_instructions: instructions33.map((item) => ({
// //         task_instruction: item.value,
// //         task_instruction_img: item.smallimage,
// //         task_instruction_img_big: item.bigimage,
// //         task_instruction_hi: item.value_hi,
// //       })),

// //       questions: currentData.map(
// //         (item: {
// //           finalcorr: string;
// //           id: number;
// //           textValue: any;
// //           smallquestionsimage: any[];
// //           test245: any;
// //           Multiples: any[];
// //           optionsslectedvalue: any;
// //           instructions: {
// //             id: any;
// //             value: any;
// //             value_hi: any;
// //             smallimage: any;
// //           }[];
// //         }) => {
// //           const hintItemEn = correctHintArray.find(
// //             (hint) => hint.id === item.id
// //           );
// //           const hintItemHi = correctHintHiArray.find(
// //             (hint) => hint.id === item.id
// //           );
// //           const imageData3Item = imagesdata3.find((img) => img.id === item.id); // Match imagesdata3 by id
// //           const longDescriptionItem = longDescriptions[item.id]; // Match English longDescriptions by id
// //           const longDescriptionHiItem = longDescriptionsHi[item.id]; // Match Hi

// //           const textValueItem = textValueData.find((tv) => tv.id === item.id);

// //           const textValueItem44 = textValueData44.find((tv) => tv.id === item.id);


// //           const textValueHiItem = textValueHiData.find(
// //             (tv) => tv.id === item.id
// //           );


// //           let filteredInstructions: any[] = [];

// //           // if (Tabname === "Availability Task" || Tabname === "उपलब्धता") {
// //           filteredInstructions = item.instructions.map((int) => {
// //             const matchedImage = instructionImageMap.find(
// //               (img) => img.mainId === item.id && img.instructionId === int.id
// //             );

// //             const him = valueArray.find(
// //               (v) => v.mainid === item.id && v.index === int.id
// //             );
// //             const hi = valueHiArray.find(
// //               (v) => v.mainid === item.id && v.index === int.id
// //             );
// //             return {
// //               step_number: int.id,
// //               step_text_en: him?.value || "",
// //               step_text_hi: hi?.value || "",
// //               step_icon: matchedImage?.image || "",
// //             };
// //           });
// //           // }
// //           const itemStepData = step1data2.find((ii) => ii.id === item.id);


// //           return {
// //             question_en: textValueItem?.value || "",
// //             question_hi: textValueHiItem?.value || "",
// // main_questions_type: !selectedmcq22[item.id]
// //   ? "single answer selections"
// //   : selectedmcq22[item.id],

// //             sample_picture: uploadedImages[item.id] || "",
// //             attemts: textValueItem44 ? textValueItem44.value : "",

// //             points: test22Value[item.id] || "",
// //             question_no: item.id,
// //             options:
// //               selectedmcq22[item.id] === "checkbox" && checkboxItems[item.id]
// //     ? checkboxItems[item.id].map((check) => ({
// //         option_big_img: check.bigimage || "",
// //         option_small_img: check.smallimage || "",
// //         option_value_en: check.value || "",
// //         option_value_hi: check.value_hi || "",
// //         checked: !!check.checked, // make sure boolean
// //       }))
// //                 : itemStepData?.Multiples.map((check: {
// //                   bigimage: any;
// //                   smallimage: any;
// //                   value: any;
// //                   value_hi: any;
// //                   ismatch?: boolean;
// //                 }) => ({
// //                   option_big_img: check.bigimage,
// //                   option_small_img: check.smallimage,
// //                   option_value_en: check.value,
// //                   option_value_hi: check.value_hi,
// //                 })) || [],

// //                 correct_option: (() => {
// //   if (!selectedmcq22[item.id] || selectedmcq22[item.id] !== "checkbox") {
// //     // Single answer or other typesstep1data2
// //     const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
// //       ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
// //       .map((check: any) => check.value || check.value_hi);
// //     return matched || [];
// //   } else {
// //     // Checkbox type
// //     const checkedOptions = checkboxItems[item.id]
// //       ?.filter((check) => check.checked) // only checked ones
// //       .map((check) => check.value || check.value_hi);
// //     return checkedOptions || [];
// //   }
// // })(),

           
// //             // correct_option: (() => {
// //             //   const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
// //             //     ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
// //             //     .map((check: any) => check.value || check.value_hi);

// //             //   return matched || [];
// //             // })(),

// //             hint: {
// //               content_type_en: hintItemEn?.value || "",
// //               content_type_hi: hintItemHi?.value || "",
// //             },
// //             instructions: filteredInstructions,
// //             question_images: imageData3Item ? imageData3Item.images : [],
// //             long_description: longDescriptionItem || null,
// //             long_description_hi: longDescriptionHiItem || null,
// //           };
// //         }
// //       ),
// //     };

// //     console.log(creattask1, "Final task payload");

// //     try {
       
// //     let response;

// // if (location.pathname.startsWith("/manage-task/edit-task")) {
// //   response = await edittasks(creattask1, token);
// // } else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
// //   response = await duplicatetask(creattask1, token);
// // } else {
// //   response = await createtask(creattask1, token);
// // }
// //       console.log("API Responsecreatettetete:", response.data.success);
// //    if (response.data.success === true) {
// //     if (location.pathname.startsWith("/manage-task/edit-task")) {
// //       showAlert("Task updated successfully!", "success");
// //     } else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
// //       showAlert("Task duplicated successfully!", "success");
// //     } else {
// //       showAlert("Task created successfully!", "success");
// //     }

// //     navigate("/manage-task");
// //   }

// //       setSubmitting(false);
// //     } catch (error: unknown) {
// //       setSubmitting(false);

// //       let errorMessage = "An error occurred while creating the task";

// //       if (error instanceof AxiosError) {
// //         // Axios error detected
// //         errorMessage =
// //           (error.response?.data as any)?.message ||
// //           (error.response?.data as any)?.error ||
// //           error.message;
// //       } else if (error instanceof Error) {
// //         // fallback for normal JS errors
// //         errorMessage = error.message;
// //       }

// //       console.error("Error creating task:", error);
// //       showAlert(errorMessage, "error");
// //     }
// //     console.log(
// //       durationUnit,
// //       "durationUnitdurationUnit",
// //       durationValue,
// //       "durationValuedurationValue"
// //     );
// //     console.log(currentData, "cdfsfsfsssdsdfs");

// //     // const steps = [
// //     //   { id: 1, name: "English" },
// //     //   { id: 2, name: "Hindi" },
// //     //   { id: 3, name: "Marathi" },
// //     // ];

// //     // const handleNextStep = () => {
// //     //   if (activeStep < steps.length) {
// //     //     setActiveStep(activeStep + 1);
// //     //   }
// //     // };
// //   }
// //   console.log(activeStep, "activeStepactiveStep");
// //   console.log(currentData, "cccccccccccc22");
// //   useEffect(() => {
// //     if (activeStep === 2 && durationValuetaskname22 === "") {
// //       setDurationValuetasakname22(durationValuetaskname);
// //     }
// //   }, [activeStep]);
// //   console.log(selectedOption, "selectedOption88888888")
// //   return (
// //     <>
// //       <Box className="task_create" sx={{ padding: "28px 32px 0px" }}>
// //         <Link
// //           href="#"
// //           sx={{
// //             textDecoration: "none",
// //             fontSize: "14px",
// //             fontWeight: "500",
// //             color: "rgba(105, 106, 107, 1)",
// //           }}
// //         >
// //           Task /
// //           <Link
// //             sx={{
// //               textDecoration: "none",
// //               fontSize: "14px",
// //               fontWeight: "600",
// //               color: "rgba(142, 2, 15, 1)",
// //             }}
// //           >
// //             {" "}
// //             Task Creation
// //           </Link>
// //         </Link>
// //         <Typography
// //           variant="h3"
// //           sx={{
// //             fontSize: "24px",
// //             fontWeight: "600",
// //             color: "#000",
// //             marginTop: "16px",
// //             borderBottom: "1px solid #E7E8E9",
// //             paddingBottom: "24px",
// //             marginBottom: "24px",
// //           }}
// //         >
// //           Create Task
// //         </Typography>
// //         <Formik
// //           className="formik-form"
// //           initialValues={{
// //             firstName: "grrr",
// //             points: durationValuepoints,
// //             duration: "",
// //             firstName_hi: "",
// //           }}

// //           validationSchema={validationSchema}
// //           onSubmit={handleSubmitSave}
// //         >
// //           {({ errors, touched }) => (
// //             <Form>
// //               <Box className="stepper-wrapper pb-4">
// //                 {steps.map((step, index) => {
// //                   const isActive = activeStep === step.id;
// //                   const isCompleted = activeStep > step.id;
// //                   return (
// //                     <Box
// //                       key={step.id}
// //                       className={`stepper-item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""
// //                         }`}
// //                     >
// //                       <Box className="step-counter"></Box>
// //                       <Box
// //                         className="step-numbers"
// //                         sx={{
// //                           fontSize: "16px",
// //                           fontWeight: "400",
// //                           color: "#696A6B",
// //                           paddingTop: "10px",

// //                         }}
// //                       >
// //                         Step {step.id}
// //                       </Box>
// //                       <Box
// //                         className="step-name"
// //                         sx={{
// //                           fontSize: "18px",
// //                           fontWeight: "600",
// //                           color: "#282829",
// //                           paddingBottom: "20px",
// //                           paddingTop: "10px"
// //                         }}
// //                       >
// //                         {step.name}
// //                       </Box>
// //                     </Box>
// //                   );
// //                 })}
// //               </Box>

// //               <Grid container spacing={3}>
// //                 <Grid item md={4}>

// //                   {(activeStep === 1 || activeStep === 2) && (
// //                     <FormControl>
// //                       <label
// //                         style={{
// //                           fontSize: "16px",
// //                           fontWeight: "500",
// //                           color: "#282829",
// //                           marginBottom: "8px",
// //                         }}
// //                       >
// //                         {currentLang.taskName}*
// //                       </label>
// //                       <TextField
// //                         name="duration"
// //                         placeholder={currentLang.enterTaskName}
// //                         value={
// //                           activeStep === 1
// //                             ? durationValuetaskname
// //                             : durationValuetaskname22
// //                         }
// //                         onChange={(e) => {
// //                           const value = e.target.value;
// //                           console.log(value, "kkkkkkssssssssss")
// //                           if (activeStep === 1) {
// //                             setDurationValuetasakname(value);
// //                           } else {
// //                             setDurationValuetasakname22(value);
// //                           }
// //                         }}
// //                         type="text"
// //                         variant="outlined"

// //                         sx={{
// //                           minWidth: {
// //                             lg: '250px',
// //                             xl: "352px"
// //                           },
// //                           borderRadius: "10px",
// //                           fontSize: "16px",
// //                           fontWeight: 500,
// //                           backgroundColor: "#FFF",
// //                           '& .MuiOutlinedInput-root': {
// //                             borderRadius: "10px",
// //                             '&.Mui-focused fieldset': {
// //                               borderColor: '#000',
// //                             },
// //                           },
// //                         }}
// //                       />
// //                       {activeStep === 1 && !durationValuetaskname && touched.firstName && (
// //                         <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
// //                           Please enter task name
// //                         </div>
// //                       )}
// //                       {activeStep === 2 && !durationValuetaskname22 && touched.firstName_hi && (
// //                         <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
// //                           Please enter task name
// //                         </div>
// //                       )}
// //                     </FormControl>
// //                   )}


// //                 </Grid>
// //                 <Grid item md={4} sx={{
// //                   minWidth: {
// //                     lg: '250px',
// //                     xl: "352px"
// //                   },
// //                 }}>



// //                   {(activeStep === 1 || activeStep === 2) && (
// //                     <FormControl>
// //                       <label
// //                         style={{
// //                           fontSize: "16px",
// //                           fontWeight: "500",
// //                           color: "#282829",
// //                           marginBottom: "8px",
// //                         }}
// //                       >
// //                         {currentLang.taskDiscriptions}
// //                       </label>
// //                       <TextField
// //                         name="discription"
// //                         placeholder={currentLang.enterDiscrition}
// //                         value={
// //                           activeStep === 1
// //                             ? Discriptionsdata
// //                             : Discriptionsdatahi
// //                         }
// //                         onChange={(e) => {
// //                           const value = e.target.value;
// //                           console.log(value, "kkkkkkssssssssss")
// //                           if (activeStep === 1) {
// //                             setDiscriptions(value);
// //                           } else {
// //                             setDiscriptionshi(value);
// //                           }
// //                         }}
// //                         type="text"
// //                         variant="outlined"

// //                         sx={{
// //                           minWidth: {
// //                             lg: '250px',
// //                             xl: "352px"
// //                           },
// //                           borderRadius: "10px",
// //                           fontSize: "16px",
// //                           fontWeight: 500,
// //                           backgroundColor: "#FFF",
// //                           '& .MuiOutlinedInput-root': {
// //                             borderRadius: "10px",
// //                             '&.Mui-focused fieldset': {
// //                               borderColor: '#000',
// //                             },
// //                           },
// //                           "@media (max-width: 12550px)": {
// //                             width: "245px",
// //                           },
// //                           "@media (max-width: 1280px)": {
// //                             width: "217px",
// //                           },
// //                         }}
// //                       />

// //                     </FormControl>
// //                   )}

// //                 </Grid>
// //                 <Grid item md={4}>
// //                   <FormControl>
// //                     <label
// //                       style={{
// //                         fontSize: "16px",
// //                         fontWeight: "500",
// //                         color: "#282829",
// //                         marginBottom: "8px",
// //                       }}
// //                     >
// //                       {currentLang.points}*
// //                     </label>

// //                     <Field name="points">
// //                       {({ field, form }: any) => {
// //                         // Ensure value is always a string
// //                         const value: string = String(durationValuepoints ?? "");

// //                         // Determine if error should show
// //                         const showError =
// //                           (form.touched.points || form.submitCount > 0) &&
// //                           (value.trim() === "" || /[^0-9]/.test(value));

// //                         // Set error message
// //                         let errorMessage = "";
// //                         if (value.trim() === "") {
// //                           errorMessage = "Please enter points.";
// //                         } else if (/[^0-9]/.test(value)) {
// //                           errorMessage = "Enter numbers only.";
// //                         }

// //                         return (
// //                           <TextField
// //                             {...field}
// //                             placeholder="Enter Total Points"
// //                             variant="outlined"
// //                             value={value} // always use safe string
// //                             error={showError}
// //                             helperText={showError ? errorMessage : ""}
// //                             onChange={(e) => {
// //                               const val = e.target.value;
// //                               form.setFieldValue(field.name, val); // keep Formik in sync
// //                               setDurationValuepoints(val); // keep local state in sync
// //                             }}
// //                             onBlur={() => form.setFieldTouched(field.name, true)}
// //                             sx={{
// //                               borderRadius: "10px",
// //                               fontSize: "16px",
// //                               fontWeight: 500,
// //                               backgroundColor: "#FFF",
// //                               "& .MuiOutlinedInput-root": {
// //                                 borderRadius: "10px",
// //                                 "&.Mui-focused fieldset": {
// //                                   borderColor: "#000",
// //                                 },
// //                               },
// //                             }}
// //                           />
// //                         );
// //                       }}
// //                     </Field>
// //                   </FormControl>


// //                 </Grid>
// //               </Grid>
// //               <Box sx={{ display: "flex" }}>
// //                 <Box
// //                   sx={{
// //                     marginTop: "28px",
// //                   }}
// //                 >
// //                   <Box sx={{ marginBottom: "8px" }}>
// //                     <label
// //                       style={{
// //                         fontSize: "16px",
// //                         fontWeight: "500",
// //                         color: "#282829",
// //                         marginBottom: "8px",
// //                       }}
// //                     >
// //                       {currentLang.selectLocation}
// //                     </label>
// //                   </Box>
// //                   <ReportDropdown
// //                     options={options}
// //                     placeholder={currentLang.selectLocation}
// //                     value={selectedOptions}
// //                     onChange={handleDropdownChange}

// //                   />
// //                 </Box>

// //                 <Box sx={{
// //                   marginTop: "28px", marginLeft: "50px", marginBottom: "20px",
// //                   "@media (max-width: 1366px)": {
// //                     marginLeft: "90px"
// //                   },
// //                   "@media (max-width: 1280px)": {
// //                     marginLeft: "70px"

// //                   },
// //                 }}>
// //                   <Box sx={{ marginBottom: "8px" }}>
// //                     <label
// //                       style={{
// //                         fontSize: "16px",
// //                         fontWeight: "500",
// //                         color: "#282829",
// //                         marginBottom: "8px",
// //                       }}
// //                     >
// //                       {currentLang.completedType}
// //                     </label>
// //                   </Box>
// //                   <MultiReportDropdown
// //                     options={options1}
// //                     placeholder={currentLang.selecttype}
// //                     value={selectedOption}
// //                     onChange={handleDropdownChange1}

                    
// //                   />
                  
// //                   <Box sx={{ marginTop: "16px", marginBottom: "8px" }}>
// //   <label
// //     style={{
// //       fontSize: "16px",
// //       fontWeight: "500",
// //       color: "#282829",
// //       marginBottom: "8px",
// //     }}
    
// //   >
// //      {currentLang.ApprovalType}
// //   </label>
// // </Box>
// // <MultiReportDropdown
// //   options={options2}   // 👈 new options array for approval type
// //   placeholder={currentLang.ApprovalType}
// //   value={selectApprovalType}
// //   onChange={handleDropdownChange2}
// // />
   
// //                 </Box>
                
// //               </Box>
              
// //               {/* <AddBonus
// //                 bouncedurationValue={bouncedurationValue}
// //                 bouncedurationUnit={bouncedurationUnit}
// //                 setbounceDurationValue={setbounceDurationValue}
// //                 setbounceDurationUnit={sebouncetDurationUnit}
// //                 bonusPoints={bonusPoints}
// //                 setBonusPoints={setBonusPoints}
// //                 lang={currentLang}
// //               /> */}
// //               <Box sx={{ marginTop: "20px" }}>
// //                 <CreateType
// //                   //  st.ate={state} setState={setState}
// //                   iconImage={iconimagggg}
// //                   faltsubmit={faltsubmit}
// //                   setIconImage={seticonimagggg}
// //                   educationalData={educationalData}
// //                   Tabname33={Tabname}
// //                   lang={currentLang}
// //                   // instructions22={instructions}
// //                   // setInstructions={setInstructions}
// //                   seteducationalData={seteducationalData}
// //                   sectionsData={sectionsData} // ✅ Pass as props
// //                   setSectionsData={setSectionsData} // ✅ Pass as props
// //                   value={value}
// //                   setValue={setValue}
// //                   setName={setName}
// //                   name={name}
// //                   Tabname={Tabname}
// //                   setTabname={setTabname}
// //                   tabsData={tabsData}
// //                   setTabsData={setTabsData}
// //                 />
// //               </Box>
// //               <Box
// //                 sx={{
// //                   backgroundColor: "#FFF",
// //                   padding: "20px 32px 20px 44px",
// //                   borderTop: "1px solid #E7E8E9",
// //                   width: "100%",
// //                   display: "flex",
// //                   alignItems: "center",
// //                   justifyContent: "space-between",
// //                   position: "sticky",
// //                   bottom: "0",
// //                   zIndex: "1",
// //                 }}
// //               >
// //                 {/* <Button onClick={() => handleBackStep(currentLang.currLang)} */}
// //                 {/* <Button onClick={() => handleBackStep(currentLang.currLang)}
// //                   sx={{ fontSize: "14px", fontWeight: "500", color: "#C8172F", textTransform: "capitalize", padding: "0" }}>
// //                   <img style={{ marginRight: "8px" }}  src={arrowleft} alt="arrowleft" />Backsss
                 
// //                 </Button> */}
// //                 <Button
// //                   onClick={() => {
// //                     if (activeStep === 2) {
// //                       handleBackStep(currentLang.currLang);
// //                     } else if (activeStep === 1) {
// //                       navigate('/manage-task');
// //                     }
// //                   }}
// //                   sx={{
// //                     fontSize: "14px",
// //                     fontWeight: "500",
// //                     color: "#C8172F",
// //                     textTransform: "capitalize",
// //                     padding: "0",
// //                   }}
// //                 >
// //                   <img style={{ marginRight: "8px" }} src={arrowleft} alt="arrowleft" />
// //                   Back
// //                 </Button>
// //                 <Box>
// //                   {/* <Button
// //                     sx={{
// //                       fontSize: "14px",
// //                       fontWeight: "500",
// //                       color: "#C8172F",
// //                       textTransform: "capitalize",
// //                       padding: "0",
// //                     }}
// //                   >
// //                     Preview
// //                   </Button> */}
// //                   {/* <Button
// //                     sx={{
// //                       fontSize: "14px",
// //                       fontWeight: "500",
// //                       color: "#C8172F",
// //                       textTransform: "capitalize",
// //                       border: "1px solid #C8172F",
// //                       borderRadius: "8px",
// //                       margin: "0 16px 0 28px",
// //                       padding: "10px 24px",
// //                     }}
// //                   >
// //                     Save Draft
// //                   </Button> */}
// //                   <Button
// //                     type="submit"
// //                     className="btn__save"
// //                     disabled={!enableSaveButton}
// //                     sx={{
// //                       fontSize: "14px",
// //                       fontWeight: "500",
// //                       color: !enableSaveButton ? "#BDBDBD" : "#FFF",
// //                       textTransform: "capitalize",
// //                       border: !enableSaveButton
// //                         ? "1px solid #BDBDBD"
// //                         : "1px solid #C8172F",
// //                       borderRadius: "8px",
// //                       padding: "10px 43px",
// //                       background: !enableSaveButton ? "#BDBDBD" : "#C8172F",
// //                       // opacity: !enableSaveButton ? 0.6 : 1,
// //                       cursor: !enableSaveButton ? "not-allowed" : "pointer",
// //                     }}
// //                   >
// //                     Save
// //                   </Button>
// //                   {activeStep === 1 && (
// //                     <Button
// //                       onClick={() => handleNextStep(currentLang.currLang)}
// //                       sx={{
// //                         fontSize: "14px",
// //                         fontWeight: "500",
// //                         color: "#C8172F",
// //                         textTransform: "capitalize",
// //                         border: "1px solid #C8172F",
// //                         borderRadius: "8px",
// //                         margin: "0 16px 0 28px",
// //                         padding: "10px 24px",
// //                       }}
// //                     >
// //                       Next
// //                     </Button>
// //                   )}

// //                   {activeStep === 2 && (
// //                     <Button
// //                       disabled
// //                       sx={{
// //                         fontSize: "14px",
// //                         fontWeight: "500",
// //                         // color: "#C8172F",
// //                         textTransform: "capitalize",
// //                         border:
// //                           activeStep === 2
// //                             ? "1px solid #BDBDBD"
// //                             : "1px solid #C8172F",
// //                         borderRadius: "8px",
// //                         margin: "0 16px 0 28px",
// //                         padding: "10px 24px",
// //                         color: activeStep === 2 ? "#BDBDBD" : "#C8172F",
// //                         borderColor: activeStep === 2 ? "#E0E0E0" : "#C8172F",
// //                         backgroundColor:
// //                           activeStep === 2 ? "#BDBDBD" : "transparent",
// //                       }}
// //                     >
// //                       Next
// //                     </Button>
// //                   )}

// //                   {/* <Button onClick={() => handleBackStep(currentLang.currLang)}>{currentLang.back}</Button> */}
// //                 </Box>
// //               </Box>
// //             </Form>
// //           )}
// //         </Formik>
// //       </Box>
// //     </>
// //   );
// // }

// // export default CreateTask;
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   FormControl,
//   Grid,
//   Link,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { Formik, Field, Form, FormikHelpers } from "formik";
// import * as Yup from "yup";
// import { AxiosError } from "axios";
// import camera from "../../../src/assests/images/camera.svg";
// import archery from "../../../src/assests/images/archery.svg";
// import AddBonus from "../../components/ReTask/AddBonus";
// import Dropdowntext from "../../components/ReTask/Dropdowntext";
// import arrowleft from "../../../src/assests/images/arrow-red.svg";
// import CreateType from "../../components/ReTask/CreateType";
// import { getToken } from "../../utils/utils";
// import { createtask, duplicatetask, edittasks, fetchTaskDetails } from "./api";
// import TargetQuestions from "../../components/TaskTabContents/TargetQuestions";
// import EducationalQuestions from "../../components/TaskTabContents/EducationalQuestions";
// import Plus from "../../../src/assests/images/add.svg";
// import pdf from "../../../src/assests/images/dicons.svg";
// import AvailbiltyQuestions from "../../components/TaskTabContents/AvailbiltyQuestions";
// import marker from "../../../src/assests/images/marker_black.svg";
// import { useTaskContext } from "../../components/store/AlltasksContext";
// import ReportDropdown from "../reports/Reportdropdown";
// import MultiReportDropdown from "../reports/multireportdropdown";
// import { getdropdowncities } from "../tasks-assigning/api";
// import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
// import { useAlert } from "../AlertContext/AlertContext";

// interface Values {
//   duration: string;
//   firstName: string;
//   points: string;
//   firstName_hi: string;
// }

// interface Option {
//   value: string;
//   label: string;
// }

// const validationSchema = Yup.object({
//   // firstName: Yup.string()
//   //   .required('First Name is required')
//   //   .min(2, 'First Name must be at least 2 characters'),
//   // points: Yup.string()
//   //   .required('Points is required')
//   //   .min(3, 'Minimum of 3 points required'),
// });

// const formValidationfordropdown = Yup.object({
//   // duration: Yup.string()
//   //   .required('Select your duration')
//   //   .min(2, 'Select your duration'),
// });

// const handleSubmitfordropdown = (values: Record<string, string>) => { };
// interface CheckboxItem {
//   id: number;
//   value: string;
//   value_hi: string; // Added value_hi field
//   checked: boolean;
//   idid: number;
//   smallimage: string;
//   bigimage: string;
// }

// interface SectionData {
//   id: number;
//   initialName: string;
//   placeholder: string;
//   markerImage: string;
//   typographyText: string;
//   textValue: string;
//   mainplaceholder: string;
//   noOfAttampt: string;
//   selectValue: string;
//   dropdownOptions: { id: number; label: string; value: string }[];
//   instructions: { id: number; value: string }[];
//   Multiples: { id: number; value: string; checkvalue: string }[];
//   Checkboxes: { id: number; value: string; checked: boolean }[];
//   rating: { initialStars: number; maxStarsOptions: number[] };
// }

// interface InstructionItem {
//   id: number;
//   value: string;
//   image: string;
// }

// const translations = {
//   en: {
//     currLang: "en",
//     taskName: "Task Name",
//     taskDiscriptions: "Task Description",
//     // taskDuration: "Task Duration",
//     points: "Total Points",
//     enterTaskName: "Enter Task Name",
//     enterDiscrition: "Enter Task Description",

//     enterPoints: "Enter Points",
//     save: "Save",
//     next: "Next",
//     back: "Back",
//     preview: "Preview",
//     saveDraft: "Save Draft",
//     //AddBonus
//     addBonusPoints: "Add Bonus Points",
//     removeBonusPoints: "Remove Bonus Points",
//     addDetailBonusPoints: "Add Details Of Bonus Points",
//     bonusPoints: "Bonus Points*",
//     bonusduration: "Bonus Duration*",
//     //Availbilty Questions
//     imgageGifVideo: "Image/Gif/Video",
//     uploadImage: "Upload Image",
//     pageLabel: " Page 1",
//     uploadText: "Drag & Drop your Image or video /Gif here or Choose file",
//     uploadSize: "PNG, JPG, GIF, SVG (Max 5 MB), video (Max 10 MB)",
//     addMore: " + Add More",
//     instruction: "Instruction",
//     addInstruction: "Add Instruction",
//     //Questions
//     option: "Option",
//     //questionPoint: "Write your Question Points here",
//     questionPoint: "Points",
//     writeHintCorrectOption: "Write a hint for the correct option",
//     addOptions: "Add Options",
//     selectCorrectOptionHint: "Select the option for the answer",
//     taskType: "Task Type",
//     selectTasktype: "Select tasks type to build the task",
//     questionsTab: "questions",
//     notes: "Notes",
//     availabilityTask: "Availability Task",
//     educationalTask: "Educational task",
//     serveyTask: "Survey Task",
//     feedbackTask: "Feedback Task",
//     dotcodescanning: "Dotcode Scanning Task",
//     Irtask: "Image Capture Task",
//     targetTask: "Target task",
//     english: "English",
//     hindi: "Hindi",
//     // marathi: "Marathi",
//     days: "Days",
//     weeks: "Weeks",
//     selectLocation: "Select Location",
//     selecttype: "Select Type",
//     //Dropdown for Dotcode scanner
//     educationalTaskDrop: "Availability Task",
//     targetTaskDrop: "Ranging Task",
//     feedbackTaskDrop: "Stock weight Task",
//     dotcodeScanningDrop: "Micro Targeting Task",
//     imageCaptureDrop: "Image Capture Task",
//     selectoption: "Select an option",
//     completedType: "Completion Type",
//     ApprovalType:"Approval Type",
//     noOfAttampt: "Number of Attempts",
//   },
//   hi: {
//     currLang: "hi",
//     taskName: "कार्य का नाम",
//     taskDiscriptions: "कार्य विवरण",
//     // taskDuration: "कार्य अवधि",
//     points: "कुल अंक",
//     enterTaskName: "कार्य का नाम दर्ज करें",
//     enterDiscrition: "कार्य विवरण दर्ज करें",

//     enterPoints: "अंक दर्ज करें",
//     save: "सहेजें",
//     next: "अगला",
//     back: "पीछे",
//     preview: "पूर्वावलोकन",
//     saveDraft: "ड्राफ्ट सहेजें",
//     //AddBonus
//     addBonusPoints: "बोनस अंक जोड़ें",
//     removeBonusPoints: "बोनस अंक हटाएँ",
//     addDetailBonusPoints: "बोनस अंकों का विवरण जोड़ें",
//     bonusPoints: "बोनस अंक*",
//     bonusduration: "बोनस अवधि*",
//     //Availbilty Questions
//     imgageGifVideo: "छवि/जीआईएफ/वीडियो",
//     uploadImage: "तस्विर अपलोड करना",
//     pageLabel: "गुगल भाषांतर",
//     uploadText: "अपनी छवि/जीआईएफ यहाँ खींचें और छोड़ें या फ़ाइल चुनें",
//     uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
//     addMore: "+ अधिक जोड़ें",
//     instruction: "अनुदेश",
//     addInstruction: "अनुदेश जोड़ें",
//     //Questions
//     option: "विकल्प",
//     questionPoint: "अंक",
//     writeHintCorrectOption: "सही विकल्प के लिए संकेत लिखें",
//     addOptions: "विकल्प",
//     selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
//     taskType: "कार्य प्रकार",
//     selectTasktype: "कार्य बनाने के लिए कार्य प्रकार चुनें",
//     questionsTab: "प्रश्न",
//     notes: "नोट्स",
//     availabilityTask: "उपलब्धता कार्य",
//     educationalTask: "शैक्षिक कार्य",
//     serveyTask: "सर्वेक्षण",
//     feedbackTask: "प्रतिक्रिया",
//     dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
//     Irtask: "छवि कैप्चर कार्य",
//     // targetTask: "उपलब्धता कार्य",
//     english: "अंग्रेज़ी",
//     hindi: "हिंदी",
//     // marathi: "मराठी",
//     days: "दिन",
//     weeks: "सप्ताह",
//     selectLocation: "स्थान चुनें",
//     selecttype: "पूर्ण प्रकार",
//     //Drop down
//     educationalTaskDrop: "उपलब्धता कार्य",
//     targetTaskDrop: "रेंजिंग कार्य",
//     feedbackTaskDrop: "स्टॉक वजन कार्य",
//     dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
//     imageCaptureDrop: "छवि कैप्चर कार्य",
//     selectoption: "एक विकल्प चुनें",
//     completedType: "पूर्ण प्रकार",
//     ApprovalType:"अनुमोदन प्रकार",
    
//     noOfAttampt: "प्रयासों की संख्या",
//   },
//   mr: {
//     currLang: "mr",
//     taskName: "कार्याचे नाव",
//     taskDiscriptions: "कार्य अवधि",

//     points: "कुल अंक",
//     enterTaskName: "कार्याचे नाव प्रविष्ट करा",
//     enterDiscrition: "कार्य विवरण दर्ज करें",
//     enterPoints: "गुण प्रविष्ट करा",
//     save: "जतन करा",
//     next: "पुढे",
//     back: "मागे",
//     preview: "पूर्वावलोकन",
//     saveDraft: "ड्राफ्ट जतन करा",
//     //AddBonus
//     addBonusPoints: "बोनस गुण जोडा",
//     removeBonusPoints: "बोनस गुण काढा",
//     addDetailBonusPoints: "बोनस गुणांचा तपशील जोडा",
//     bonusPoints: "बोनस गुण*",
//     bonusduration: "बोनस कालावधी*",
//     //Availbilty Questions
//     imgageGifVideo: "प्रतिमा/जीआयएफ/व्हिडिओ",
//     uploadImage: " पृष्ठ 1",
//     pageLabel: " पृष्ठ 1",
//     uploadText: "आपली प्रतिमा/जीआयएफ इथे ओढा आणि सोडा किंवा फाईल निवडा",
//     uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
//     addMore: "+ अधिक जोड़ा",
//     instruction: "सूचना",
//     addInstruction: "सूचना जोड़ा",
//     //Questions
//     initialName: "",
//     placeholder: " string",
//     typographyText: "string",
//     option: "पर्याय",
//     questionPoint: "अंक",
//     writeHintCorrectOption: "योग्य पर्यायासाठी सूचना लिहा",
//     addOptions: "पर्याय",
//     selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
//     taskType: "कार्य प्रकार",
//     selectTasktype: "कार्य तयार करण्यासाठी कार्य प्रकार निवडा",
//     questionsTab: "प्रश्न",
//     notes: "नोंद",
//     availabilityTask: "उपलब्धता कार्य",
//     educationalTask: "शैक्षणिक कार्य",
//     serveyTask: "सर्वेक्षण",
//     feedbackTask: "अभिप्राय",
//     dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
//     Irtask: "छवि कैप्चर कार्य",
//     // targetTask: "उपलब्धता कार्य",
//     english: "इंग्रजी",
//     hindi: "हिंदी",
//     // marathi: "मराठी",
//     days: "दिवस",
//     weeks: "आठवडे",
//     selectLocation: "स्थान निवडा",
//     selecttype: "प्रकार चुनें",
//     //Drop down
//     educationalTaskDrop: "उपलब्धता कार्य",
//     targetTaskDrop: "रेंजिंग कार्य",
//     feedbackTaskDrop: "स्टॉक वजन कार्य",
//     dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
//     imageCaptureDrop: "छवि कैप्चर कार्य",
//     selectoption: "एक विकल्प चुनें",
//     completedType: "पूर्ण प्रकार",
//     ApprovalType:"अनुमोदन प्रकार",

//     noOfAttampt: "प्रयासों की संख्या",
//   },
// };

// function CreateTask() {
//   const token = getToken();
//   const {
//     setActiveStep,
//     activeStep,
//     correctHintArray,
   
//     correctHintHiArray,
//     textValueData,
//     textValueHiData,
//     instructionImageMap,
//     setInstructionImageMap,
//     valueHiArray,
//     valueArray,
//     test22Value,
//     step1data,
//     step1data2,
//     checkboxItems,
//     selectedItems,
//     textValueData44,
//     selectedOption1
//   } = useTaskContext();

//   const languageMap: Record<number, "en" | "hi" | "mr"> = {
//     1: "en",
//     2: "hi",
//     3: "mr",
//   };

//   const handleNextStep = (param = "en") => {
//     if (activeStep < steps.length) {
//       setActiveStep(activeStep + 1);
//     }
//     setCurrentLang(languageMap[activeStep + 1]);
//   };
//   const handleBackStep = (param?: string) => {
//     if (activeStep > 1) {
//       const prevStep = activeStep - 1;
//       setActiveStep(prevStep);
//       setCurrentLang(languageMap[prevStep]);

//       // Update currentData with selectedmcq for selectValue
//       setCurrentData(
//         currentData.map((item: any) => ({
//           ...item,
//           selectValue: selectedmcq,
//         }))
//       );
//     }
//   };
//   const { id } = useParams();
//   const { duplicate_id } = useParams();
//   const currentLang = translations[languageMap[activeStep]];
//   const steps = [
//     { id: 1, name: currentLang.english },
//     { id: 2, name: currentLang.hindi },
//   ];

//   const getAvailabilityContent = () => (
//     <AvailbiltyQuestions lang={currentLang} />
//   );
//   const getEducationalContent = () => (
//     <EducationalQuestions lang={currentLang} />
//   );
//   const getTargetContent = () => <TargetQuestions lang={currentLang} />;
//   useEffect(() => {
//     setTabsData([
//       {
//         label: "Item Two",
//         value: "2",
//         content: getEducationalContent(),
//         isEditable: false,
//         name: currentLang.educationalTask,
//         name_hi: "शैक्षिक कार्य",
//         image: camera,
//         isActive: false,
//       },

//       {
//         label: "Item Three",
//         value: "3",
//         content: getEducationalContent(),
//         isEditable: false,
//         name: currentLang.serveyTask,
//         name_hi: "सर्वेक्षण",
//         image: camera,
//         isActive: false,
//       },
//       {
//         label: "Item Three",
//         value: "4",
//         content: getEducationalContent(),
//         isEditable: false,
//         name: currentLang.feedbackTask,
//         name_hi: "प्रतिक्रिया",
//         image: camera,
//         isActive: false,
//       },

//       {
//         label: "Item Six",
//         value: "6",
//         content: getEducationalContent(),
//         isEditable: false,
//         name: currentLang.dotcodescanning,
//         name_hi: "डॉटकोड स्कैनिंग कार्य",
//         image: camera,
//         isActive: false,
//       },
//       {
//         label: "Item Seven",
//         value: "7",
//         content: getEducationalContent(),
//         isEditable: false,
//         name: currentLang.Irtask,
//         name_hi: "छवि कैप्चर कार्य",
//         image: camera,
//         isActive: false,
//       },
//     ]);
//   }, [currentLang]);

//   const [dropdowncities, setdropdowncities] = useState<any[]>([]);

//   useEffect(() => {
//     const fetchdropdowncities = async () => {
//       try {
//         const response = await getdropdowncities();
//         const cities = response.data.data || [];
//         setdropdowncities(
//           cities.map((city: string) => ({ value: city, label: city }))
//         );
//       } catch (error) {
//         console.error("Error fetching cities:", error);
//       }
//     };

//     fetchdropdowncities();
//   }, []);

//   const [tabsData, setTabsData] = useState([
//     {
//       label: "Item OneE",
//       value: "1",
//       content: <AvailbiltyQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Availability Task",
//       name_hi: "उपलब्धता कार्य",
//       image: pdf,
//       isActive: true,
//     },
//     {
//       label: "Item Two",
//       value: "2",
//       content: <EducationalQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Educational task",
//       name_hi: "शैक्षिक कार्य",
//       image: camera,
//       isActive: false,
//     },
//     {
//       label: "Item Three",
//       value: "3",
//       content: <TargetQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Target taskfffffff",
//       name_hi: "",
//       image: archery,
//       isActive: false,
//     },
//     {
//       label: "Item Four",
//       value: "4",
//       content: <EducationalQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Servey Task",
//       name_hi: "",
//       image: archery,
//       isActive: false,
//     },
//     {
//       label: "Item Five",
//       value: "5",
//       content: <EducationalQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "FeedBack Task",
//       name_hi: "",
//       image: archery,
//       isActive: false,
//     },
//     {
//       label: "Item Six",
//       value: "6",
//       content: <EducationalQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Dotcodescaning Task",
//       name_hi: "",
//       image: archery,
//       isActive: false,
//     },
//     {
//       label: "Item Seven",
//       value: "7",
//       content: <EducationalQuestions lang={currentLang} />,
//       isEditable: false,
//       name: "Image Capture Task",
//       name_hi: "",
//       image: archery,
//       isActive: false,
//     },
//   ]);

//   const [value, setValue] = useState<string>("");
//   const [iconimagggg, seticonimagggg] = useState("cccccccccc");
//   const [bouncedurationValue, setbounceDurationValue] = useState<string>("");
//   const [bouncedurationUnit, sebouncetDurationUnit] = useState<string>("");
//   const [bonusPoints, setBonusPoints] = useState("");
//   const [name, setName] = useState<string>("");
//   const [durationValue, setDurationValue] = useState<string>("");
//   const [durationValuepoints, setDurationValuepoints] = useState<string>("");
//   const [durationValuetaskname, setDurationValuetasakname] = useState<string>("");
//   const [durationValuetaskname22, setDurationValuetasakname22] = useState<string>("");
//   const [Discriptionsdata, setDiscriptions] = useState<string>("");
//   const [Discriptionsdatahi, setDiscriptionshi] = useState<string>("");
//   const [durationUnit, setDurationUnit] = useState<string>("");
//   const [taskName, setTaskName] = useState<string>("");
//   const navigate = useNavigate()
//   const {
//     sectionsData,
//     setSectionsData,
//     fileName,
//     educationalData,
//     seteducationalData,
//     Tabname,
//     setTabname,
//     instructions33,
//     longDescriptions,
//     longDescriptionsHi,
//     imagesdata3,
//     setfinalll,
//     finalll,
//     imagesdata,
//     imagesdata1,
//     currentData,
//     currentLang: contextLang,
//     setCurrentLang,
//     uploadedImages, setUploadedImages,
//     setallinone, allinone

//   } = useTaskContext();

//   const { showAlert } = useAlert();

//   const options = [
//     { value: "", label: "All Location" },
//     ...dropdowncities.map((item) => ({
//       value: item.value,
//       label: item.label,
//     })),
//   ];

//   const options1: Option[] = [
//     { label: "Completed", value: "1" },
//     { label: "Partially", value: "2" },
//   ];

//   const options2:Option[]=[
//      { label: "Required", value: "1" },
//     { label: "Not Required", value: "2" },
//   ];
  
//   const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
//   const [selectedOption, setSelectedOption] = useState<string>("");
//   const [selectApprovalType,setselectApprovalType]=useState<string>("");
//   const [faltsubmit, setfaltsubmit] = useState(false);

//   const handleDropdownChange1 = (selected: Option | null) => {
//     const newValue = selected ? selected.value : "";
//     setSelectedOption(newValue);
//   };
//   const handleDropdownChange2 = (selected: Option | null) => {
//     const newValue = selected ? selected.value : "";
//     setselectApprovalType(newValue); // Fixed: Update the correct state (selectApprovalType)
//   };
//   const handleDropdownChange = (
//     selected: { value: string; label: string }[] | null
//   ) => {
//     const newValues = selected ? selected.map((opt) => opt.value) : [];
//     setSelectedOptions(newValues);
//   };
//   const enableSaveButton = activeStep >= 2;

//   const {
//     setimagesdata1,
//     setimagesdata,

//     setTextValueData,
//     setTextValueHiData,
//     setTest22Value,
//     setValueArray,
//     setCorrectHintArray,
//     setCorrectHintHiArray,
//     setValueHiArray,
//     setstep1data2,
//     setFiles,
//     files,
//     setInstructions,
//     instructions33default, setInstructionsdefault,
//     setCurrentData,
//     selectedmcq,
//     currentlength,
//     setcurrentlength,
//     setdefaultvalues,
//     setdefaultipostermages,
//     setdefaulttaskiconimages,
//     defaulttaskiconimages,
//     setSelectedOption1,setTextValueData44,
//     textValueDatadefault, setTextValueDatadefault,
//     textValueDatadefaulthindi, setTextValueDatadefaulthindi,
//     setstep1data2default,
//     setCheckboxItems,
//     setstep1data2defaultchekbox,
//     allhintsteps, setallhitssteps,
//     selectedmcq22,
//  setSelectedmcq22,

//   } = useTaskContext();

// const [selectedmcq221, setSelectedmcq221] = useState<Record<number, string>>({});

//   useEffect(() => {
//    if (!id && !duplicate_id) return;// Only run if id exists

//     const fetchData = async () => {
//       try {
//         const defaultSmallImage = process.env.PUBLIC_URL + "/assets/stepIcon5.svg";
//    const taskIdToFetch = id ? String(id) : duplicate_id ?? "";
// const response: any = await fetchTaskDetails(taskIdToFetch, token);
//         const taskData = response.data.data.task;
//         setdefaultvalues(taskData)
//         setdefaultipostermages([taskData.intro_poster])
//         setdefaulttaskiconimages([taskData.task_icon])
       
// if (taskData.completed_type === "completed") {
//   setSelectedOption("1");
// } else if (taskData.completed_type === "partially") {
//   setSelectedOption("2");
// }

// // Fixed: Set the correct state for approval_type
// if (taskData.approval_type === "Required") {
//   setselectApprovalType("1"); // Fixed: Use setselectApprovalType
// } else if (taskData.approval_type === "Not Required") {
//   setselectApprovalType("2"); // Fixed: Use setselectApprovalType
// }

//        const instructionData = response.data.data.taskinstructions.map((item: { id: any; task_instruction: any; task_instruction_hi: any; task_instruction_img: any; task_instruction_img_big: any; task_instruction_vidio_big: any; }) => ({
//   id: item.id,
//   value: item.task_instruction,
//   value_hi: item.task_instruction_hi || "",
//   smallimage: item.task_instruction_img || defaultSmallImage,
//   bigimage: item.task_instruction_img_big || item.task_instruction_vidio_big || defaultSmallImage,
// }));

//         if (taskData.subtasks.length > 0) {
//           setcurrentlength(taskData.subtasks.length)
//         }

//         setallinone(taskData.subtasks)
//      const hitssteps = taskData.subtasks.flatMap((item: { hint: { steps: any; }; question_no: number }) =>
//   (item.hint?.steps || []).map((step: { step_number: any; step_text_en: any; step_text_hi: any; step_icon: any; }) => ({
//     questions_id: item.question_no,
//     step_number: step.step_number,
//     step_text_en: step.step_text_en,
//     step_text_hi: step.step_text_hi,
//     step_icon: step.step_icon
//   }))
// );

// setallhitssteps(hitssteps);


//         // Prefill task instructions
//    setDiscriptions(taskData.task_discriptions_en)
//    setDiscriptionshi(taskData.task_discriptions_hi)
       
//         setInstructionsdefault(instructionData);

//         // Prefill task-level data
//         setDurationValuetasakname(taskData.task || "");
//         setDurationValuetasakname22(taskData.task_title_hi  || "");
//         setDurationValuepoints(taskData.credit_points?.toString() || "");
//         setBonusPoints(taskData.bonus_point?.toString() || "");

//         const subtaskMap: Record<string, string> = {
//   "Availability Task": "Availability",
//   "Ranging Task": "Ranging",
//   "Micro Targeting Task": "Micro Targeting",
// };

// setSelectedOption1(subtaskMap[response.data.data.task_subtasks.subtask_type_en as string] || "");

//         if (taskData.duration) {
//           const [value, unit] = taskData.duration.split(" ");
//           setDurationValue(value || "");
//           setDurationUnit(unit || "");
//         }

//         if (taskData.location) {
//           setSelectedOptions(taskData.location.split(","));
//         }
//         setTabname(taskData.task_type === "Educational" ? "Educational task" :taskData.task_type === "Survey" ? "Survey Task":taskData.task_type === "Feedback" ? "Feedback Task":taskData.task_type === "Dotcode Scanning Task" ? "Dotcode Scanning Task":taskData.task_type === "Image Capture Task" ? "Image Capture Task": taskData.task_type);




//      const updated = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
//   acc[item.question_no] = String(item.points ?? "");
//   return acc;
// }, {});

// setTest22Value(updated);
       
//      const updated1 = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
//   acc[item.question_no] = String(item.sample_picture ?? "");
//   return acc;
// }, {});


// setUploadedImages(updated1)
// taskData.subtasks.forEach((item: any) => {
//   setTextValueData44(prev => [
//     ...prev,
//     { id: item.question_no, value: String(item.max_no_of_attempts ?? "") }
//   ]);
// });


// const mappedStep1Data2 = taskData.subtasks.map((item: any) => ({
//   id: item.question_no,
//   Multiples: item.options.map((option: any, index: number) => ({
//     id: index + 1, // 1-based index for Multiples
//     value: option.option_value_en || "", // option value
//     value_hi: option.option_value_hi || "", // same as value or from another field if you have Hindi
//     checkvalue: `check${index + 1}`, // or option.correct_option if you want
//     smallimage: option.option_small_img || "",
//     bigimage: option.option_big_img || "",
//     mainid: item.question_no,
//     ismatch: option.correct_option === "1" // true if correct_option === "1"
//   }))
// }));

// setstep1data2default(mappedStep1Data2);


// const newValues: any[] = [];

// taskData.subtasks.forEach((item: any, subIndex: number) => {
//   item.hint.steps.forEach((option: any, optIndex: number) => {
//     newValues.push({
//       mainid: item.question_no,
//       index: optIndex + 1,
//       value: option.step_text_en || "",
//     });
//   });
// });

// setValueArray(newValues);





// // 2. When looping, type prev explicitly
// taskData.subtasks.forEach((item: any) => {
//   setSelectedmcq22((prev: Record<number, string>): Record<number, string> => ({
//     ...prev,
//     [item.question_no]: item.main_questions_type || "",
//   }));
// });









// const newValues1: any[] = [];

// taskData.subtasks.forEach((item: any, subIndex: number) => {
//   item.hint.steps.forEach((option: any, optIndex: number) => {
//     newValues1.push({
//       mainid: item.question_no,
//       index: optIndex + 1,
//       value: option.step_text_hi || "",
//     });
//   });
// });

// setValueHiArray(newValues1);


// const newValuesiamges: any[] = [];

// taskData.subtasks.forEach((item: any) => {
//   item.hint.steps.forEach((option: any, optIndex: number) => {
//     newValuesiamges.push({
//       mainId: item.question_no,
//       instructionId: optIndex + 1,
//       image: option.step_icon || "",
//     });
//   });
// });

// setInstructionImageMap(newValuesiamges);


// const defaultCheckboxItems = taskData.subtasks.reduce(
//   (acc: { [key: number]: CheckboxItem[] }, item: any) => {
//     if (item.main_questions_type === 'checkbox') {
//       acc[item.question_no] = item.options.map((option: any, index: number) => ({
//         id: index + 1,
//         value: option.option_value_en || "",
//         value_hi: option.option_value_hi || "",
//         checked: option.correct_option === "1",
//         idid: item.question_no,
//         smallimage: option.option_small_img || "",
//         bigimage: option.option_big_img || "",
//       }));
//     } else {
//       // acc[item.question_no] = []; // optional: initialize empty array for non-checkbox questions
//     }
//     return acc;
//   },
//   {}
// );

// setCheckboxItems(defaultCheckboxItems);



// const daa = taskData.subtasks.reduce((acc: { id: number; index: number; value: string }[], item: any, i: number) => {
//   acc.push({
//     id: item.question_no,
//     index: i, // incrementing index
//     value: item.hint?.content_type_en || ""
//   });
//   return acc;
// }, []);

// setCorrectHintArray(daa);


// const daa1 = taskData.subtasks.reduce((acc: { id: number; index: number; value: string }[], item: any, i: number) => {
//   acc.push({
//     id: item.question_no,
//     index: i, // incrementing index
//     value: item.hint?.content_type_hi || ""
//   });
//   return acc;
// }, []);

// setCorrectHintHiArray(daa1);


// const initialTextValueData44 = taskData.subtasks.map((item: any) => ({
//   id: item.question_no,
//   value: String(item.question ?? "")
// }));


// // Set state once
// setTextValueDatadefault(initialTextValueData44);



// const initialTextValueData44hindi = taskData.subtasks.map((item: any) => ({
//   id: item.question_no,
//   value: String(item.question_hi ?? "")
// }));

// setTextValueDatadefaulthindi(initialTextValueData44hindi);


// taskData.subtasks.forEach((item: any) => {
//   setTextValueHiData(prev => [
//     ...prev,
//     { id: item.question_no, value: String(item.question_hi ?? "") }
//   ]);
// });

//         setValue(
//           taskData.task_type === "Educational" || taskData.task_type === "शैक्षिक"
//             ? "2"
//             : taskData.task_type === "Survey Task" || taskData.task_type === "सर्वेक्षण" || taskData.task_type === "Survey"
//               ? "3"
//               : taskData.task_type === "Feedback Task" || taskData.task_type === "प्रतिक्रिया" || taskData.task_type === "Feedback"
//                 ? "4"


//                 : taskData.task_type === "Dotcode Scanning Task" || taskData.task_type ===  "डॉटकोड स्कैनिंग कार्य"

//                 ? "6"

//                 : taskData.task_type === "Image Capture Task"
//                 ? "7"

               
//                 : ""
//         );


//         if (taskData.task_icon) {
//           seticonimagggg(taskData.task_icon);
//           setimagesdata1([{ id: 1, images: [taskData.task_icon] }]);
//         }

//         // Prefill question-related data
//         const subtasks = taskData.subtasks || [];

//         // Set textValueData (question_en)
//         setTextValueData(
//           subtasks.map((subtask: any) => ({
//             id: subtask.question_no,
//             value: subtask.question_en || "",
//           }))
//         );

//         // Set textValueHiData (question_hi)
//         setTextValueHiData(
//           subtasks.map((subtask: any) => ({
//             id: subtask.question_no,
//             value: subtask.question_hi || "",
//           }))
//         );


//       } catch (error) {
//         console.error("Error fetching task details:", error);
//         showAlert("Failed to load task details", "error");
//       }
//     };

//     fetchData();
//   }, [
//     id,
//     token,

//     setDurationValuetasakname,
//     setDurationValuetasakname22,
//     setDurationValuepoints,
//     setBonusPoints,
//     setDurationValue,
//     setDurationUnit,
//     setSelectedOptions,
//     setTabname,
//     duplicate_id,
//     setValue,
//     seticonimagggg,
//     setSectionsData,
//     seteducationalData,
//     setimagesdata,
//     setimagesdata1,
//     setFiles,
//     setInstructions,
//     setTextValueData,
//     setTextValueHiData,
//     setTest22Value,
//     setUploadedImages,
//     setCorrectHintArray,
//     setCorrectHintHiArray,
//     setValueArray,
//     setValueHiArray,
//     setInstructionImageMap,
//     setCurrentData,
//   ]);

//   const location = useLocation();

//   const handleSubmitSave = async (
//     values: Values,
//     { setSubmitting }: FormikHelpers<Values>
//   ) => {
//     setfaltsubmit(true)

//     console.log(values, "vassslues");
//     const fields = [durationValue, durationValuetaskname22, durationUnit, durationValuetaskname];

//     if (fields.every(f => !f)) {
//       showAlert("error");
//       setSubmitting(false);
//       return;
//     }

//     if (value === "") {
//       showAlert("please select one Tab");
//       setSubmitting(false);
//       return;
//     }

//     // Added validation for Approval Type
//     if (selectApprovalType === "") {
//       showAlert("Please select an approval type");
//       setSubmitting(false);
//       return;
//     }

//     // Filter sectionsData to remove empty text values
//     const filteredSections = sectionsData.filter(
//       (item) => item.textValue !== "" && item.textValue !== null
//     );

//     const tabNameMapEn: Record<string, string> = {
//       "Availability Task": "Availability",
//       "Educational task": "Educational",
//       "शैक्षिक कार्य": "Educational",
//       "शैक्षणिक कार्य": "Educational",
//       "Survey Task": "Survey",
//       "सर्वेक्षण": "Survey",
//       "Feedback Task": "Feedback",
//       "प्रतिक्रिया": "Feedback",
//     };


//     const tabNameMapHi: Record<string, string> = {
//       "Availability Task": "उपलब्धता",
//       "Educational task": "शैक्षिक",
//       "शैक्षिक कार्य": "शैक्षिक",
//       "शैक्षणिक कार्य": "शैक्षिक",
//       "Survey Task": "सर्वेक्षण",
//       "सर्वेक्षण": "सर्वेक्षण",
//       "Feedback Task": "प्रतिक्रिया",
//       "प्रतिक्रिया": "प्रतिक्रिया",
//     };

//     const fallbackNameEn = tabNameMapEn[Tabname] || Tabname;
//     const fallbackNameHi = tabNameMapHi[Tabname] || "";
//     let taskMap = {
//       "Availability": { en: "Availability Task", hi: "उपलब्धता कार्य" },
//       "Ranging": { en: "Ranging Task", hi: "रेंजिंग कार्य" },
//       "Stock weight": { en: "Stock weight Task", hi: "स्टॉक भार कार्य" },
//       "Micro Targeting": { en: "Micro Targeting Task", hi: "सूक्ष्म लक्ष्यीकरण कार्य" }
//     };

//     const creattask1 = {
//       task_id:id?id:'',
//       task_en: durationValuetaskname || "",
//       task_hi: activeStep === 2
//         ? (durationValuetaskname22 === "" ? durationValuetaskname : durationValuetaskname22)
//         : "",
//       selectedOption: taskMap[selectedOption1 as keyof typeof taskMap]?.en || "",
//       selectedOption_hi: taskMap[selectedOption1 as keyof typeof taskMap]?.hi || "",

//       task_discriptions: Discriptionsdata || "",
//       task_discriptions_hi: activeStep === 2
//         ? (Discriptionsdatahi === "" ? Discriptionsdata : Discriptionsdatahi)
//         : "",
//       completed_type: selectedOption === "1"
//         ? "completed"
//         : selectedOption === "2"
//           ? "partially"
//           : "",
//           approval_type:
//           selectApprovalType === "1"
//         ? "Required"
//         : selectApprovalType === "2"
//           ? "Not Required"
//           : "",
//       credit_points: durationValuepoints,
//       duration: `${durationValue || ""} ${durationUnit || ""}`.trim(),
//       require_task_approval: false,
//       bonus_point: bonusPoints,
//       bonus_duration: `${bouncedurationValue || ""} ${bouncedurationUnit || ""
//         }`.trim(),
//       location: selectedOptions.length ? selectedOptions.join(",") : "",
//       task_type_hi:
//         activeStep === 2
//           ? (
//             tabsData
//               .filter((item) => item.isEditable === true)
//               .map((item) => item.name_hi)
//               .join(",") || fallbackNameHi
//           )
//           : "",
//       task_type_en:
//         tabsData
//           .filter((item) => item.isEditable === true)
//           .map((item) => item.name)
//           .join(",") || fallbackNameEn,
//       task_icon: imagesdata1
//         .filter((item) => item.images.length > 0)
//         .map((item) => item.images.join(","))
//         .join(","),
//       intro_poster: imagesdata
//         .filter((item) => item.images.length > 0)
//         .flatMap((item) => item.images),

//       task_instructions: instructions33.map((item) => ({
//         task_instruction: item.value,
//         task_instruction_img: item.smallimage,
//         task_instruction_img_big: item.bigimage,
//         task_instruction_hi: item.value_hi,
//       })),

//       questions: currentData.map(
//         (item: {
//           finalcorr: string;
//           id: number;
//           textValue: any;
//           smallquestionsimage: any[];
//           test245: any;
//           Multiples: any[];
//           optionsslectedvalue: any;
//           instructions: {
//             id: any;
//             value: any;
//             value_hi: any;
//             smallimage: any;
//           }[];
//         }) => {
//           const hintItemEn = correctHintArray.find(
//             (hint) => hint.id === item.id
//           );
//           const hintItemHi = correctHintHiArray.find(
//             (hint) => hint.id === item.id
//           );
//           const imageData3Item = imagesdata3.find((img) => img.id === item.id); // Match imagesdata3 by id
//           const longDescriptionItem = longDescriptions[item.id]; // Match English longDescriptions by id
//           const longDescriptionHiItem = longDescriptionsHi[item.id]; // Match Hi

//           const textValueItem = textValueData.find((tv) => tv.id === item.id);

//           const textValueItem44 = textValueData44.find((tv) => tv.id === item.id);


//           const textValueHiItem = textValueHiData.find(
//             (tv) => tv.id === item.id
//           );


//           let filteredInstructions: any[] = [];

//           // if (Tabname === "Availability Task" || Tabname === "उपलब्धता") {
//           filteredInstructions = item.instructions.map((int) => {
//             const matchedImage = instructionImageMap.find(
//               (img) => img.mainId === item.id && img.instructionId === int.id
//             );

//             const him = valueArray.find(
//               (v) => v.mainid === item.id && v.index === int.id
//             );
//             const hi = valueHiArray.find(
//               (v) => v.mainid === item.id && v.index === int.id
//             );
//             return {
//               step_number: int.id,
//               step_text_en: him?.value || "",
//               step_text_hi: hi?.value || "",
//               step_icon: matchedImage?.image || "",
//             };
//           });
//           // }
//           const itemStepData = step1data2.find((ii) => ii.id === item.id);


//           return {
//             question_en: textValueItem?.value || "",
//             question_hi: textValueHiItem?.value || "",
// main_questions_type: !selectedmcq22[item.id]
//   ? "single answer selections"
//   : selectedmcq22[item.id],

//             sample_picture: uploadedImages[item.id] || "",
//             attemts: textValueItem44 ? textValueItem44.value : "",

//             points: test22Value[item.id] || "",
//             question_no: item.id,
//             options:
//               selectedmcq22[item.id] === "checkbox" && checkboxItems[item.id]
//     ? checkboxItems[item.id].map((check) => ({
//         option_big_img: check.bigimage || "",
//         option_small_img: check.smallimage || "",
//         option_value_en: check.value || "",
//         option_value_hi: check.value_hi || "",
//         checked: !!check.checked, // make sure boolean
//       }))
//                 : itemStepData?.Multiples.map((check: {
//                   bigimage: any;
//                   smallimage: any;
//                   value: any;
//                   value_hi: any;
//                   ismatch?: boolean;
//                 }) => ({
//                   option_big_img: check.bigimage,
//                   option_small_img: check.smallimage,
//                   option_value_en: check.value,
//                   option_value_hi: check.value_hi,
//                 })) || [],

//                 correct_option: (() => {
//   if (!selectedmcq22[item.id] || selectedmcq22[item.id] !== "checkbox") {
//     // Single answer or other typesstep1data2
//     const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
//       ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
//       .map((check: any) => check.value || check.value_hi);
//     return matched || [];
//   } else {
//     // Checkbox type
//     const checkedOptions = checkboxItems[item.id]
//       ?.filter((check) => check.checked) // only checked ones
//       .map((check) => check.value || check.value_hi);
//     return checkedOptions || [];
//   }
// })(),

           
//             // correct_option: (() => {
//             //   const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
//             //     ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
//             //     .map((check: any) => check.value || check.value_hi);

//             //   return matched || [];
//             // })(),

//             hint: {
//               content_type_en: hintItemEn?.value || "",
//               content_type_hi: hintItemHi?.value || "",
//             },
//             instructions: filteredInstructions,
//             question_images: imageData3Item ? imageData3Item.images : [],
//             long_description: longDescriptionItem || null,
//             long_description_hi: longDescriptionHiItem || null,
//           };
//         }
//       ),
//     };

//     console.log(creattask1, "Final task payload");

//     try {
       
//     let response;

// if (location.pathname.startsWith("/manage-task/edit-task")) {
//   response = await edittasks(creattask1, token);
// } else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
//   response = await duplicatetask(creattask1, token);
// } else {
//   response = await createtask(creattask1, token);
// }
//       console.log("API Responsecreatettetete:", response.data.success);
//    if (response.data.success === true) {
//     if (location.pathname.startsWith("/manage-task/edit-task")) {
//       showAlert("Task updated successfully!", "success");
//     } else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
//       showAlert("Task duplicated successfully!", "success");
//     } else {
//       showAlert("Task created successfully!", "success");
//     }

//     navigate("/manage-task");
//   }

//       setSubmitting(false);
//     } catch (error: unknown) {
//       setSubmitting(false);

//       let errorMessage = "An error occurred while creating the task";

//       if (error instanceof AxiosError) {
//         // Axios error detected
//         errorMessage =
//           (error.response?.data as any)?.message ||
//           (error.response?.data as any)?.error ||
//           error.message;
//       } else if (error instanceof Error) {
//         // fallback for normal JS errors
//         errorMessage = error.message;
//       }

//       console.error("Error creating task:", error);
//       showAlert(errorMessage, "error");
//     }
//   }
//   useEffect(() => {
//     if (activeStep === 2 && durationValuetaskname22 === "") {
//       setDurationValuetasakname22(durationValuetaskname);
//     }
//   }, [activeStep]);
//   return (
//     <>
//       <Box className="task_create" sx={{ padding: "28px 32px 0px" }}>
//         <Link
//           href="#"
//           sx={{
//             textDecoration: "none",
//             fontSize: "14px",
//             fontWeight: "500",
//             color: "rgba(105, 106, 107, 1)",
//           }}
//         >
//           Task /
//           <Link
//             sx={{
//               textDecoration: "none",
//               fontSize: "14px",
//               fontWeight: "600",
//               color: "rgba(142, 2, 15, 1)",
//             }}
//           >
//             {" "}
//             Task Creation
//           </Link>
//         </Link>
//         <Typography
//           variant="h3"
//           sx={{
//             fontSize: "24px",
//             fontWeight: "600",
//             color: "#000",
//             marginTop: "16px",
//             borderBottom: "1px solid #E7E8E9",
//             paddingBottom: "24px",
//             marginBottom: "24px",
//           }}
//         >
//           Create Task
//         </Typography>
//         <Formik
//           className="formik-form"
//           initialValues={{
//             firstName: "grrr",
//             points: durationValuepoints,
//             duration: "",
//             firstName_hi: "",
//           }}

//           validationSchema={validationSchema}
//           onSubmit={handleSubmitSave}
//         >
//           {({ errors, touched }) => (
//             <Form>
//               <Box className="stepper-wrapper pb-4">
//                 {steps.map((step, index) => {
//                   const isActive = activeStep === step.id;
//                   const isCompleted = activeStep > step.id;
//                   return (
//                     <Box
//                       key={step.id}
//                       className={`stepper-item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""
//                         }`}
//                     >
//                       <Box className="step-counter"></Box>
//                       <Box
//                         className="step-numbers"
//                         sx={{
//                           fontSize: "16px",
//                           fontWeight: "400",
//                           color: "#696A6B",
//                           paddingTop: "10px",

//                         }}
//                       >
//                         Step {step.id}
//                       </Box>
//                       <Box
//                         className="step-name"
//                         sx={{
//                           fontSize: "18px",
//                           fontWeight: "600",
//                           color: "#282829",
//                           paddingBottom: "20px",
//                           paddingTop: "10px"
//                         }}
//                       >
//                         {step.name}
//                       </Box>
//                     </Box>
//                   );
//                 })}
//               </Box>

//               <Grid container spacing={3}>
//                 <Grid item md={4}>

//                   {(activeStep === 1 || activeStep === 2) && (
//                     <FormControl>
//                       <label
//                         style={{
//                           fontSize: "16px",
//                           fontWeight: "500",
//                           color: "#282829",
//                           marginBottom: "8px",
//                         }}
//                       >
//                         {currentLang.taskName}*
//                       </label>
//                       <TextField
//                         name="duration"
//                         placeholder={currentLang.enterTaskName}
//                         value={
//                           activeStep === 1
//                             ? durationValuetaskname
//                             : durationValuetaskname22
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (activeStep === 1) {
//                             setDurationValuetasakname(value);
//                           } else {
//                             setDurationValuetasakname22(value);
//                           }
//                         }}
//                         type="text"
//                         variant="outlined"

//                         sx={{
//                           minWidth: {
//                             lg: '250px',
//                             xl: "352px"
//                           },
//                           borderRadius: "10px",
//                           fontSize: "16px",
//                           fontWeight: 500,
//                           backgroundColor: "#FFF",
//                           '& .MuiOutlinedInput-root': {
//                             borderRadius: "10px",
//                             '&.Mui-focused fieldset': {
//                               borderColor: '#000',
//                             },
//                           },
//                         }}
//                       />
//                       {activeStep === 1 && !durationValuetaskname && touched.firstName && (
//                         <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
//                           Please enter task name
//                         </div>
//                       )}
//                       {activeStep === 2 && !durationValuetaskname22 && touched.firstName_hi && (
//                         <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
//                           Please enter task name
//                         </div>
//                       )}
//                     </FormControl>
//                   )}


//                 </Grid>
//                 <Grid item md={4} sx={{
//                   minWidth: {
//                     lg: '250px',
//                     xl: "352px"
//                   },
//                 }}>



//                   {(activeStep === 1 || activeStep === 2) && (
//                     <FormControl>
//                       <label
//                         style={{
//                           fontSize: "16px",
//                           fontWeight: "500",
//                           color: "#282829",
//                           marginBottom: "8px",
//                         }}
//                       >
//                         {currentLang.taskDiscriptions}
//                       </label>
//                       <TextField
//                         name="discription"
//                         placeholder={currentLang.enterDiscrition}
//                         value={
//                           activeStep === 1
//                             ? Discriptionsdata
//                             : Discriptionsdatahi
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (activeStep === 1) {
//                             setDiscriptions(value);
//                           } else {
//                             setDiscriptionshi(value);
//                           }
//                         }}
//                         type="text"
//                         variant="outlined"

//                         sx={{
//                           minWidth: {
//                             lg: '250px',
//                             xl: "352px"
//                           },
//                           borderRadius: "10px",
//                           fontSize: "16px",
//                           fontWeight: 500,
//                           backgroundColor: "#FFF",
//                           '& .MuiOutlinedInput-root': {
//                             borderRadius: "10px",
//                             '&.Mui-focused fieldset': {
//                               borderColor: '#000',
//                             },
//                           },
//                           "@media (max-width: 12550px)": {
//                             width: "245px",
//                           },
//                           "@media (max-width: 1280px)": {
//                             width: "217px",
//                           },
//                         }}
//                       />

//                     </FormControl>
//                   )}

//                 </Grid>
//                 <Grid item md={4}>
//                   <FormControl>
//                     <label
//                       style={{
//                         fontSize: "16px",
//                         fontWeight: "500",
//                         color: "#282829",
//                         marginBottom: "8px",
//                       }}
//                     >
//                       {currentLang.points}*
//                     </label>

//                     <Field name="points">
//                       {({ field, form }: any) => {
//                         // Ensure value is always a string
//                         const value: string = String(durationValuepoints ?? "");

//                         // Determine if error should show
//                         const showError =
//                           (form.touched.points || form.submitCount > 0) &&
//                           (value.trim() === "" || /[^0-9]/.test(value));

//                         // Set error message
//                         let errorMessage = "";
//                         if (value.trim() === "") {
//                           errorMessage = "Please enter points.";
//                         } else if (/[^0-9]/.test(value)) {
//                           errorMessage = "Enter numbers only.";
//                         }

//                         return (
//                           <TextField
//                             {...field}
//                             placeholder="Enter Total Points"
//                             variant="outlined"
//                             value={value} // always use safe string
//                             error={showError}
//                             helperText={showError ? errorMessage : ""}
//                             onChange={(e) => {
//                               const val = e.target.value;
//                               form.setFieldValue(field.name, val); // keep Formik in sync
//                               setDurationValuepoints(val); // keep local state in sync
//                             }}
//                             onBlur={() => form.setFieldTouched(field.name, true)}
//                             sx={{
//                               borderRadius: "10px",
//                               fontSize: "16px",
//                               fontWeight: 500,
//                               backgroundColor: "#FFF",
//                               "& .MuiOutlinedInput-root": {
//                                 borderRadius: "10px",
//                                 "&.Mui-focused fieldset": {
//                                   borderColor: "#000",
//                                 },
//                               },
//                             }}
//                           />
//                         );
//                       }}
//                     </Field>
//                   </FormControl>


//                 </Grid>
//               </Grid>
//               <Box sx={{ display: "flex" }}>
//                 <Box
//                   sx={{
//                     marginTop: "28px",
//                   }}
//                 >
//                   <Box sx={{ marginBottom: "8px" }}>
//                     <label
//                       style={{
//                         fontSize: "16px",
//                         fontWeight: "500",
//                         color: "#282829",
//                         marginBottom: "8px",
//                       }}
//                     >
//                       {currentLang.selectLocation}
//                     </label>
//                   </Box>
//                   <ReportDropdown
//                     options={options}
//                     placeholder={currentLang.selectLocation}
//                     value={selectedOptions}
//                     onChange={handleDropdownChange}

//                   />
//                 </Box>

//                 <Box sx={{
//                   marginTop: "28px", 
//                   marginLeft: "50px", 
//                   marginBottom: "20px",
//                   "@media (max-width: 1366px)": {
//                     marginLeft: "90px"
//                   },
//                   "@media (max-width: 1280px)": {
//                     marginLeft: "70px"
//                   },
//                 }}>
//                   {/* New Grid for side-by-side dropdowns */}
//                   <Grid container spacing={2}>
//                     <Grid item md={6} xs={12}> {/* Full width on small screens, half on medium+ */}
//                       <Box sx={{ marginBottom: "8px" }}>
//                         <label
//                           style={{
//                             fontSize: "16px",
//                             fontWeight: "500",
//                             color: "#282829",
//                             marginBottom: "8px",
//                           }}
//                         >
//                           {currentLang.completedType}
//                         </label>
//                       </Box>
//                       <MultiReportDropdown
//                         options={options1}
//                         placeholder={currentLang.selecttype}
//                         value={selectedOption}
//                         onChange={handleDropdownChange1}
//                       />
//                     </Grid>
//                     <Grid item md={6} xs={12}> {/* Full width on small screens, half on medium+ */}
//                       <Box sx={{ marginBottom: "8px" }}>
//                         <label
//                           style={{
//                             fontSize: "16px",
//                             fontWeight: "500",
//                             color: "#282829",
//                             marginBottom: "8px",
//                           }}
//                         >
//                           {currentLang.ApprovalType}
//                         </label>
//                       </Box>
//                       <MultiReportDropdown
//                         options={options2}
//                         placeholder={currentLang.ApprovalType}
//                         value={selectApprovalType}
//                         onChange={handleDropdownChange2}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
                
//               </Box>
              
//               {/* <AddBonus
//                 bouncedurationValue={bouncedurationValue}
//                 bouncedurationUnit={bouncedurationUnit}
//                 setbounceDurationValue={setbounceDurationValue}
//                 setbounceDurationUnit={sebouncetDurationUnit}
//                 bonusPoints={bonusPoints}
//                 setBonusPoints={setBonusPoints}
//                 lang={currentLang}
//               /> */}
//               <Box sx={{ marginTop: "20px" }}>
//                 <CreateType
//                   //  st.ate={state} setState={setState}
//                   iconImage={iconimagggg}
//                   faltsubmit={faltsubmit}
//                   setIconImage={seticonimagggg}
//                   educationalData={educationalData}
//                   Tabname33={Tabname}
//                   lang={currentLang}
//                   // instructions22={instructions}
//                   // setInstructions={setInstructions}
//                   seteducationalData={seteducationalData}
//                   sectionsData={sectionsData} // ✅ Pass as props
//                   setSectionsData={setSectionsData} // ✅ Pass as props
//                   value={value}
//                   setValue={setValue}
//                   setName={setName}
//                   name={name}
//                   Tabname={Tabname}
//                   setTabname={setTabname}
//                   tabsData={tabsData}
//                   setTabsData={setTabsData}
//                 />
//               </Box>
//               <Box
//                 sx={{
//                   backgroundColor: "#FFF",
//                   padding: "20px 32px 20px 44px",
//                   borderTop: "1px solid #E7E8E9",
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   position: "sticky",
//                   bottom: "0",
//                   zIndex: "1",
//                 }}
//               >
//                 <Button
//                   onClick={() => {
//                     if (activeStep === 2) {
//                       handleBackStep(currentLang.currLang);
//                     } else if (activeStep === 1) {
//                       navigate('/manage-task');
//                     }
//                   }}
//                   sx={{
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#C8172F",
//                     textTransform: "capitalize",
//                     padding: "0",
//                   }}
//                 >
//                   <img style={{ marginRight: "8px" }} src={arrowleft} alt="arrowleft" />
//                   Back
//                 </Button>
//                 <Box>
//                   <Button
//                     type="submit"
//                     className="btn__save"
//                     disabled={!enableSaveButton}
//                     sx={{
//                       fontSize: "14px",
//                       fontWeight: "500",
//                       color: !enableSaveButton ? "#BDBDBD" : "#FFF",
//                       textTransform: "capitalize",
//                       border: !enableSaveButton
//                         ? "1px solid #BDBDBD"
//                         : "1px solid #C8172F",
//                       borderRadius: "8px",
//                       padding: "10px 43px",
//                       background: !enableSaveButton ? "#BDBDBD" : "#C8172F",
//                       cursor: !enableSaveButton ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     Save
//                   </Button>
//                   {activeStep === 1 && (
//                     <Button
//                       onClick={() => handleNextStep(currentLang.currLang)}
//                       sx={{
//                         fontSize: "14px",
//                         fontWeight: "500",
//                         color: "#C8172F",
//                         textTransform: "capitalize",
//                         border: "1px solid #C8172F",
//                         borderRadius: "8px",
//                         margin: "0 16px 0 28px",
//                         padding: "10px 24px",
//                       }}
//                     >
//                       Next
//                     </Button>
//                   )}

//                   {activeStep === 2 && (
//                     <Button
//                       disabled
//                       sx={{
//                         fontSize: "14px",
//                         fontWeight: "500",
//                         textTransform: "capitalize",
//                         border:
//                           activeStep === 2
//                             ? "1px solid #BDBDBD"
//                             : "1px solid #C8172F",
//                         borderRadius: "8px",
//                         margin: "0 16px 0 28px",
//                         padding: "10px 24px",
//                         color: activeStep === 2 ? "#BDBDBD" : "#C8172F",
//                         borderColor: activeStep === 2 ? "#E0E0E0" : "#C8172F",
//                         backgroundColor:
//                           activeStep === 2 ? "#BDBDBD" : "transparent",
//                       }}
//                     >
//                       Next
//                     </Button>
//                   )}
//                 </Box>
//               </Box>
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </>
//   );
// }

// export default CreateTask;
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, Field, Form, FormikHelpers } from "formik";
import * as Yup from "yup";
import { AxiosError } from "axios";
import camera from "../../../src/assests/images/camera.svg";
import archery from "../../../src/assests/images/archery.svg";
import AddBonus from "../../components/ReTask/AddBonus";
import Dropdowntext from "../../components/ReTask/Dropdowntext";
import arrowleft from "../../../src/assests/images/arrow-red.svg";
import CreateType from "../../components/ReTask/CreateType";
import { getToken } from "../../utils/utils";
import { createtask, duplicatetask, edittasks, fetchTaskDetails } from "./api";
import TargetQuestions from "../../components/TaskTabContents/TargetQuestions";
import EducationalQuestions from "../../components/TaskTabContents/EducationalQuestions";
import Plus from "../../../src/assests/images/add.svg";
import pdf from "../../../src/assests/images/dicons.svg";
import AvailbiltyQuestions from "../../components/TaskTabContents/AvailbiltyQuestions";
import marker from "../../../src/assests/images/marker_black.svg";
import { useTaskContext } from "../../components/store/AlltasksContext";
import ReportDropdown from "../reports/Reportdropdown";
import MultiReportDropdown from "../reports/multireportdropdown";
import { getdropdowncities } from "../tasks-assigning/api";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../AlertContext/AlertContext";

interface Values {
  duration: string;
  firstName: string;
  points: string;
  firstName_hi: string;
}
interface EditableCheckboxItem {
  id: number;
  value: string;
  value_hi?: string;
  checked?: boolean;
  smallimage?: string;
  bigimage?: string;
  main_question_id?: number | null;
}

interface Option {
  value: string;
  label: string;
}

const validationSchema = Yup.object({
  // firstName: Yup.string()
  //   .required('First Name is required')
  //   .min(2, 'First Name must be at least 2 characters'),
  // points: Yup.string()
  //   .required('Points is required')
  //   .min(3, 'Minimum of 3 points required'),
});

const formValidationfordropdown = Yup.object({
  // duration: Yup.string()
  //   .required('Select your duration')
  //   .min(2, 'Select your duration'),
});

const handleSubmitfordropdown = (values: Record<string, string>) => { };
interface CheckboxItem {
  id: number;
  value: string;
  value_hi: string; // Added value_hi field
  checked: boolean;
  idid: number;
  smallimage: string;
  bigimage: string;
  main_question_id?: number; // Added property to fix type error
}

interface SectionData {
  id: number;
  initialName: string;
  placeholder: string;
  markerImage: string;
  typographyText: string;
  textValue: string;
  mainplaceholder: string;
  noOfAttampt: string;
  selectValue: string;
  dropdownOptions: { id: number; label: string; value: string }[];
  instructions: { id: number; value: string }[];
  Multiples: { id: number; value: string; checkvalue: string }[];
  Checkboxes: { id: number; value: string; checked: boolean }[];
  rating: { initialStars: number; maxStarsOptions: number[] };
}

interface InstructionItem {
  id: number;
  value: string;
  image: string;
}
interface InstructionItem {
  id: number;
  value: string;
  value_hi: string;
  smallimage?: string;
}

interface StepOption {
  id?: number;
  value: string;
  value_hi: string;
  bigimage?: string;
  smallimage?: string;
  ismatch?: boolean;
}

interface StepDataItem {
  id: number;
  main_questions_type: string;
  main_question_id?: number;
  Multiples: StepOption[];
}

// interface CheckboxItem {
//   id: number;
//   value: string;
//   value_hi: string;
//   checked: boolean;
//   smallimage?: string;
//   bigimage?: string;
//   main_question_id?: number;
// }

interface CurrentDataItem {
  id: number;
  finalcorr?: string;
  textValue?: string;
  smallquestionsimage?: any[];
  test245?: any;
  Multiples?: StepOption[];
  optionsslectedvalue?: any;
  instructions: InstructionItem[];
}

interface QuestionPayload {
  question_en: string;
  question_hi: string;
  main_questions_type: string;
  sample_picture: string;
  attemts: string | number;
  points: string | number;
  question_no: number;
  options: any[];
  correct_option: any[];
  hint: { content_type_en: string; content_type_hi: string };
  instructions: any[];
  question_images: string[];
  long_description: string | null;
  long_description_hi: string | null;
}
const translations = {
  en: {
    currLang: "en",
    taskName: "Task Name",
    taskDiscriptions: "Task Description",
    // taskDuration: "Task Duration",
    points: "Total Points",
    enterTaskName: "Enter Task Name",
    enterDiscrition: "Enter Task Description",

    enterPoints: "Enter Points",
    save: "Save",
    next: "Next",
    back: "Back",
    preview: "Preview",
    saveDraft: "Save Draft",
    //AddBonus
    addBonusPoints: "Add Bonus Points",
    removeBonusPoints: "Remove Bonus Points",
    addDetailBonusPoints: "Add Details Of Bonus Points",
    bonusPoints: "Bonus Points*",
    bonusduration: "Bonus Duration*",
    //Availbilty Questions
    imgageGifVideo: "Image/Gif/Video",
    uploadImage: "Upload Image",
    pageLabel: " Page 1",
    uploadText: "Drag & Drop your Image or video /Gif here or Choose file",
    uploadSize: "PNG, JPG, GIF, SVG (Max 5 MB), video (Max 10 MB)",
    addMore: " + Add More",
    instruction: "Instruction",
    addInstruction: "Add Instruction",
    //Questions
    option: "Option",
    //questionPoint: "Write your Question Points here",
    questionPoint: "Points",
    writeHintCorrectOption: "Write a hint for the correct option",
    addOptions: "Add Options",
    selectCorrectOptionHint: "Select the option for the answer",
    taskType: "Task Type",
    selectTasktype: "Select tasks type to build the task",
    questionsTab: "questions",
    notes: "Notes",
    availabilityTask: "Availability Task",
    educationalTask: "Educational task",
    serveyTask: "Survey Task",
    feedbackTask: "Feedback Task",
    dotcodescanning: "Dotcode Scanning Task",
    Irtask: "Image Capture Task",
    targetTask: "Target task",
    english: "English",
    hindi: "Hindi",
    // marathi: "Marathi",
    days: "Days",
    weeks: "Weeks",
    selectLocation: "Select Location",
    selecttype: "Select Type",
    //Dropdown for Dotcode scanner
    educationalTaskDrop: "Availability Task",
    targetTaskDrop: "Ranging Task",
    feedbackTaskDrop: "Stock weight Task",
    dotcodeScanningDrop: "Micro Targeting Task",
    imageCaptureDrop: "Image Capture Task",
    selectoption: "Select an option",
    completedType: "Completion Type",
    ApprovalType:"Approval Type",
    noOfAttampt: "Number of Attempts",
  },
  hi: {
    currLang: "hi",
    taskName: "कार्य का नाम",
    taskDiscriptions: "कार्य विवरण",
    // taskDuration: "कार्य अवधि",
    points: "कुल अंक",
    enterTaskName: "कार्य का नाम दर्ज करें",
    enterDiscrition: "कार्य विवरण दर्ज करें",

    enterPoints: "अंक दर्ज करें",
    save: "सहेजें",
    next: "अगला",
    back: "पीछे",
    preview: "पूर्वावलोकन",
    saveDraft: "ड्राफ्ट सहेजें",
    //AddBonus
    addBonusPoints: "बोनस अंक जोड़ें",
    removeBonusPoints: "बोनस अंक हटाएँ",
    addDetailBonusPoints: "बोनस अंकों का विवरण जोड़ें",
    bonusPoints: "बोनस अंक*",
    bonusduration: "बोनस अवधि*",
    //Availbilty Questions
    imgageGifVideo: "छवि/जीआईएफ/वीडियो",
    uploadImage: "तस्विर अपलोड करना",
    pageLabel: "गुगल भाषांतर",
    uploadText: "अपनी छवि/जीआईएफ यहाँ खींचें और छोड़ें या फ़ाइल चुनें",
    uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
    addMore: "+ अधिक जोड़ें",
    instruction: "अनुदेश",
    addInstruction: "अनुदेश जोड़ें",
    //Questions
    option: "विकल्प",
    questionPoint: "अंक",
    writeHintCorrectOption: "सही विकल्प के लिए संकेत लिखें",
    addOptions: "विकल्प",
    selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
    taskType: "कार्य प्रकार",
    selectTasktype: "कार्य बनाने के लिए कार्य प्रकार चुनें",
    questionsTab: "प्रश्न",
    notes: "नोट्स",
    availabilityTask: "उपलब्धता कार्य",
    educationalTask: "शैक्षिक कार्य",
    serveyTask: "सर्वेक्षण",
    feedbackTask: "प्रतिक्रिया",
    dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
    Irtask: "छवि कैप्चर कार्य",
    // targetTask: "उपलब्धता कार्य",
    english: "अंग्रेज़ी",
    hindi: "हिंदी",
    // marathi: "मराठी",
    days: "दिन",
    weeks: "सप्ताह",
    selectLocation: "स्थान चुनें",
    selecttype: "पूर्ण प्रकार",
    //Drop down
    educationalTaskDrop: "उपलब्धता कार्य",
    targetTaskDrop: "रेंजिंग कार्य",
    feedbackTaskDrop: "स्टॉक वजन कार्य",
    dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
    imageCaptureDrop: "छवि कैप्चर कार्य",
    selectoption: "एक विकल्प चुनें",
    completedType: "पूर्ण प्रकार",
    ApprovalType:"अनुमोदन प्रकार",
    
    noOfAttampt: "प्रयासों की संख्या",
  },
  mr: {
    currLang: "mr",
    taskName: "कार्याचे नाव",
    taskDiscriptions: "कार्य अवधि",

    points: "कुल अंक",
    enterTaskName: "कार्याचे नाव प्रविष्ट करा",
    enterDiscrition: "कार्य विवरण दर्ज करें",
    enterPoints: "गुण प्रविष्ट करा",
    save: "जतन करा",
    next: "पुढे",
    back: "मागे",
    preview: "पूर्वावलोकन",
    saveDraft: "ड्राफ्ट जतन करा",
    //AddBonus
    addBonusPoints: "बोनस गुण जोडा",
    removeBonusPoints: "बोनस गुण काढा",
    addDetailBonusPoints: "बोनस गुणांचा तपशील जोडा",
    bonusPoints: "बोनस गुण*",
    bonusduration: "बोनस कालावधी*",
    //Availbilty Questions
    imgageGifVideo: "प्रतिमा/जीआयएफ/व्हिडिओ",
    uploadImage: " पृष्ठ 1",
    pageLabel: " पृष्ठ 1",
    uploadText: "आपली प्रतिमा/जीआयएफ इथे ओढा आणि सोडा किंवा फाईल निवडा",
    uploadSize: "पीएनजी, जेपीजी, जीआईएफ, एसवीजी (अधिकतम 1 एमबी)",
    addMore: "+ अधिक जोड़ा",
    instruction: "सूचना",
    addInstruction: "सूचना जोड़ा",
    //Questions
    initialName: "",
    placeholder: " string",
    typographyText: "string",
    option: "पर्याय",
    questionPoint: "अंक",
    writeHintCorrectOption: "योग्य पर्यायासाठी सूचना लिहा",
    addOptions: "पर्याय",
    selectCorrectOptionHint: "उत्तर के लिए विकल्प चुनें",
    taskType: "कार्य प्रकार",
    selectTasktype: "कार्य तयार करण्यासाठी कार्य प्रकार निवडा",
    questionsTab: "प्रश्न",
    notes: "नोंद",
    availabilityTask: "उपलब्धता कार्य",
    educationalTask: "शैक्षणिक कार्य",
    serveyTask: "सर्वेक्षण",
    feedbackTask: "अभिप्राय",
    dotcodescanning: "डॉटकोड स्कैनिंग कार्य",
    Irtask: "छवि कैप्चर कार्य",
    // targetTask: "उपलब्धता कार्य",
    english: "इंग्रजी",
    hindi: "हिंदी",
    // marathi: "मराठी",
    days: "दिवस",
    weeks: "आठवडे",
    selectLocation: "स्थान निवडा",
    selecttype: "प्रकार चुनें",
    //Drop down
    educationalTaskDrop: "उपलब्धता कार्य",
    targetTaskDrop: "रेंजिंग कार्य",
    feedbackTaskDrop: "स्टॉक वजन कार्य",
    dotcodeScanningDrop: "सूक्ष्म लक्ष्य कार्य",
    imageCaptureDrop: "छवि कैप्चर कार्य",
    selectoption: "एक विकल्प चुनें",
    completedType: "पूर्ण प्रकार",
    ApprovalType:"अनुमोदन प्रकार",

    noOfAttampt: "प्रयासों की संख्या",
  },
};

function CreateTask() {
  const token = getToken();
  const {
    setActiveStep,
    activeStep,
    correctHintArray,
   
    correctHintHiArray,
    textValueData,
    textValueHiData,
    instructionImageMap,
    setInstructionImageMap,
    valueHiArray,
    valueArray,
    test22Value,
    step1data,
    step1data2,
    checkboxItems,
    selectedItems,
    textValueData44,
    selectedOption1
  } = useTaskContext();

  const languageMap: Record<number, "en" | "hi" | "mr"> = {
    1: "en",
    2: "hi",
    3: "mr",
  };

  const handleNextStep = (param = "en") => {
    if (activeStep < steps.length) {
      setActiveStep(activeStep + 1);
    }
    setCurrentLang(languageMap[activeStep + 1]);
  };
  const handleBackStep = (param?: string) => {
    if (activeStep > 1) {
      const prevStep = activeStep - 1;
      setActiveStep(prevStep);
      setCurrentLang(languageMap[prevStep]);

      // Update currentData with selectedmcq for selectValue
      setCurrentData(
        currentData.map((item: any) => ({
          ...item,
          selectValue: selectedmcq,
        }))
      );
    }
  };
  
  const { id } = useParams();
  const { duplicate_id } = useParams();
  const currentLang = translations[languageMap[activeStep]];
  const steps = [
    { id: 1, name: currentLang.english },
    { id: 2, name: currentLang.hindi },
  ];

  const getAvailabilityContent = () => (
    <AvailbiltyQuestions lang={currentLang} />
  );
  const getEducationalContent = () => (
    <EducationalQuestions lang={currentLang} />
  );
  const getTargetContent = () => <TargetQuestions lang={currentLang} />;
  useEffect(() => {
    setTabsData([
      {
        label: "Item Two",
        value: "2",
        content: getEducationalContent(),
        isEditable: false,
        name: currentLang.educationalTask,
        name_hi: "शैक्षिक कार्य",
        image: camera,
        isActive: false,
      },

      {
        label: "Item Three",
        value: "3",
        content: getEducationalContent(),
        isEditable: false,
        name: currentLang.serveyTask,
        name_hi: "सर्वेक्षण",
        image: camera,
        isActive: false,
      },
      {
        label: "Item Three",
        value: "4",
        content: getEducationalContent(),
        isEditable: false,
        name: currentLang.feedbackTask,
        name_hi: "प्रतिक्रिया",
        image: camera,
        isActive: false,
      },

      {
        label: "Item Six",
        value: "6",
        content: getEducationalContent(),
        isEditable: false,
        name: currentLang.dotcodescanning,
        name_hi: "डॉटकोड स्कैनिंग कार्य",
        image: camera,
        isActive: false,
      },
      {
        label: "Item Seven",
        value: "7",
        content: getEducationalContent(),
        isEditable: false,
        name: currentLang.Irtask,
        name_hi: "छवि कैप्चर कार्य",
        image: camera,
        isActive: false,
      },
    ]);
  }, [currentLang]);

  const [dropdowncities, setdropdowncities] = useState<any[]>([]);

  useEffect(() => {
    const fetchdropdowncities = async () => {
      try {
        const response = await getdropdowncities();
        const cities = response.data.data || [];
        setdropdowncities(
          cities.map((city: string) => ({ value: city, label: city }))
        );
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchdropdowncities();
  }, []);

  const [tabsData, setTabsData] = useState([
    {
      label: "Item OneE",
      value: "1",
      content: <AvailbiltyQuestions lang={currentLang} />,
      isEditable: false,
      name: "Availability Task",
      name_hi: "उपलब्धता कार्य",
      image: pdf,
      isActive: true,
    },
    {
      label: "Item Two",
      value: "2",
      content: <EducationalQuestions lang={currentLang} />,
      isEditable: false,
      name: "Educational task",
      name_hi: "शैक्षिक कार्य",
      image: camera,
      isActive: false,
    },
    {
      label: "Item Three",
      value: "3",
      content: <TargetQuestions lang={currentLang} />,
      isEditable: false,
      name: "Target taskfffffff",
      name_hi: "",
      image: archery,
      isActive: false,
    },
    {
      label: "Item Four",
      value: "4",
      content: <EducationalQuestions lang={currentLang} />,
      isEditable: false,
      name: "Servey Task",
      name_hi: "",
      image: archery,
      isActive: false,
    },
    {
      label: "Item Five",
      value: "5",
      content: <EducationalQuestions lang={currentLang} />,
      isEditable: false,
      name: "FeedBack Task",
      name_hi: "",
      image: archery,
      isActive: false,
    },
    {
      label: "Item Six",
      value: "6",
      content: <EducationalQuestions lang={currentLang} />,
      isEditable: false,
      name: "Dotcodescaning Task",
      name_hi: "",
      image: archery,
      isActive: false,
    },
    {
      label: "Item Seven",
      value: "7",
      content: <EducationalQuestions lang={currentLang} />,
      isEditable: false,
      name: "Image Capture Task",
      name_hi: "",
      image: archery,
      isActive: false,
    },
  ]);

  const [value, setValue] = useState<string>("");
  const [iconimagggg, seticonimagggg] = useState("cccccccccc");
  const [bouncedurationValue, setbounceDurationValue] = useState<string>("");
  const [bouncedurationUnit, sebouncetDurationUnit] = useState<string>("");
  const [bonusPoints, setBonusPoints] = useState("");
  const [name, setName] = useState<string>("");
  const [durationValue, setDurationValue] = useState<string>("");
  const [durationValuepoints, setDurationValuepoints] = useState<string>("");
  const [durationValuetaskname, setDurationValuetasakname] = useState<string>("");
  const [durationValuetaskname22, setDurationValuetasakname22] = useState<string>("");
  const [Discriptionsdata, setDiscriptions] = useState<string>("");
  const [Discriptionsdatahi, setDiscriptionshi] = useState<string>("");
  const [durationUnit, setDurationUnit] = useState<string>("");
  const [taskName, setTaskName] = useState<string>("");
  const navigate = useNavigate()
  const {
    sectionsData,
    setSectionsData,
    fileName,
    educationalData,
    seteducationalData,
    Tabname,
    setTabname,
    instructions33,
    longDescriptions,
    longDescriptionsHi,
    imagesdata3,
    setfinalll,
    finalll,
    imagesdata,
    imagesdata1,
    currentData,
    currentLang: contextLang,
    setCurrentLang,
    uploadedImages, setUploadedImages,
    setallinone, allinone

  } = useTaskContext();

  const { showAlert } = useAlert();

  const options = [
    { value: "", label: "All Location" },
    ...dropdowncities.map((item) => ({
      value: item.value,
      label: item.label,
    })),
  ];

  const options1: Option[] = [
    { label: "Completed", value: "1" },
    { label: "Partially", value: "2" },
  ];

  const options2:Option[]=[
     { label: "Required", value: "1" },
    { label: "Not Required", value: "2" },
  ];
  
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [selectApprovalType,setselectApprovalType]=useState<string>("");
  const [faltsubmit, setfaltsubmit] = useState(false);

  const handleDropdownChange1 = (selected: Option | null) => {
    const newValue = selected ? selected.value : "";
    setSelectedOption(newValue);
  };
  const handleDropdownChange2 = (selected: Option | null) => {
    const newValue = selected ? selected.value : "";
    setselectApprovalType(newValue); // Fixed: Update the correct state (selectApprovalType)
  };
  const handleDropdownChange = (
    selected: { value: string; label: string }[] | null
  ) => {
    const newValues = selected ? selected.map((opt) => opt.value) : [];
    setSelectedOptions(newValues);
  };
  const enableSaveButton = activeStep >= 2;

  const {
    setimagesdata1,
    setimagesdata,

    setTextValueData,
    setTextValueHiData,
    setTest22Value,
    setValueArray,
    setCorrectHintArray,
    setCorrectHintHiArray,
    setValueHiArray,
    setstep1data2,
    setFiles,
    files,
    setInstructions,
    instructions33default, setInstructionsdefault,
    setCurrentData,
    selectedmcq,
    currentlength,
    setcurrentlength,
    setdefaultvalues,
    setdefaultipostermages,
    setdefaulttaskiconimages,
    defaulttaskiconimages,
    setSelectedOption1,setTextValueData44,
    textValueDatadefault, setTextValueDatadefault,
    textValueDatadefaulthindi, setTextValueDatadefaulthindi,
    setstep1data2default,
    setCheckboxItems,
    setstep1data2defaultchekbox,
    allhintsteps, setallhitssteps,
    selectedmcq22,
 setSelectedmcq22,

  } = useTaskContext();

const [selectedmcq221, setSelectedmcq221] = useState<Record<number, string>>({});

  useEffect(() => {
   if (!id && !duplicate_id) return;// Only run if id exists

    const fetchData = async () => {
      try {
        // const defaultSmallImage = process.env.PUBLIC_URL + "/assets/stepIcon5.svg";
   const taskIdToFetch = id ? String(id) : duplicate_id ?? "";
const response: any = await fetchTaskDetails(taskIdToFetch, token);
        const taskData = response.data.data.task;
        setdefaultvalues(taskData)
        setdefaultipostermages([taskData.intro_poster])
        setdefaulttaskiconimages([taskData.task_icon])
       
if (taskData.completed_type === "completed") {
  setSelectedOption("1");
} else if (taskData.completed_type === "partially") {
  setSelectedOption("2");
}

// Fixed: Set the correct state for approval_type
if (taskData.approval_type === "Required") {
  setselectApprovalType("1"); // Fixed: Use setselectApprovalType
} else if (taskData.approval_type === "Not Required") {
  setselectApprovalType("2"); // Fixed: Use setselectApprovalType
}

       const instructionData = response.data.data.taskinstructions.map((item: { id: any; task_instruction: any; task_instruction_hi: any; task_instruction_img: any; task_instruction_img_big: any; task_instruction_vidio_big: any; }) => ({
  id: item.id,
  value: item.task_instruction,
  value_hi: item.task_instruction_hi || "",
  smallimage: item.task_instruction_img || "",
  bigimage: item.task_instruction_img_big || item.task_instruction_vidio_big || "",
}));

        if (taskData.subtasks.length > 0) {
          setcurrentlength(taskData.subtasks.length)
        }

        setallinone(taskData.subtasks)
     const hitssteps = taskData.subtasks.flatMap((item: { hint: { steps: any; }; question_no: number }) =>
  (item.hint?.steps || []).map((step: { step_number: any; step_text_en: any; step_text_hi: any; step_icon: any; }) => ({
    questions_id: item.question_no,
    step_number: step.step_number,
    step_text_en: step.step_text_en,
    step_text_hi: step.step_text_hi,
    step_icon: step.step_icon
  }))
);

setallhitssteps(hitssteps);


        // Prefill task instructions
   setDiscriptions(taskData.task_discriptions_en)
   setDiscriptionshi(taskData.task_discriptions_hi)
       
        setInstructionsdefault(instructionData);

        // Prefill task-level data
        setDurationValuetasakname(taskData.task || "");
        setDurationValuetasakname22(taskData.task_title_hi  || "");
        setDurationValuepoints(taskData.credit_points?.toString() || "");
        setBonusPoints(taskData.bonus_point?.toString() || "");

        const subtaskMap: Record<string, string> = {
  "Availability Task": "Availability",
  "Ranging Task": "Ranging",
  "Micro Targeting Task": "Micro Targeting",
};

setSelectedOption1(subtaskMap[response.data.data.task_subtasks.subtask_type_en as string] || "");

        if (taskData.duration) {
          const [value, unit] = taskData.duration.split(" ");
          setDurationValue(value || "");
          setDurationUnit(unit || "");
        }

        if (taskData.location) {
          setSelectedOptions(taskData.location.split(","));
        }
        setTabname(taskData.task_type === "Educational" ? "Educational task" :taskData.task_type === "Survey" ? "Survey Task":taskData.task_type === "Feedback" ? "Feedback Task":taskData.task_type === "Dotcode Scanning Task" ? "Dotcode Scanning Task":taskData.task_type === "Image Capture Task" ? "Image Capture Task": taskData.task_type);




     const updated = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
  acc[item.question_no] = String(item.points ?? "");
  return acc;
}, {});

setTest22Value(updated);
       
     const updated1 = taskData.subtasks.reduce((acc: Record<number, string>, item: any) => {
  acc[item.question_no] = String(item.sample_picture ?? "");
  return acc;
}, {});


setUploadedImages(updated1)
taskData.subtasks.forEach((item: any) => {
  setTextValueData44(prev => [
    ...prev,
    { id: item.question_no, value: String(item.max_no_of_attempts ?? "") }
  ]);
});


const mappedStep1Data2 = taskData.subtasks.map((item: any) => ({
  id: item.question_no,
  Multiples: item.options.map((option: any, index: number) => ({
    id: index + 1, // 1-based index for Multiples
    value: option.option_value_en || "", // option value
    value_hi: option.option_value_hi || "", // same as value or from another field if you have Hindi
    checkvalue: `check${index + 1}`, // or option.correct_option if you want
    smallimage: option.option_small_img || "",
    bigimage: option.option_big_img || "",
    mainid: item.question_no,
    ismatch: option.correct_option === "1" // true if correct_option === "1"
  }))
}));

setstep1data2default(mappedStep1Data2);


const newValues: any[] = [];

taskData.subtasks.forEach((item: any, subIndex: number) => {
  item.hint.steps.forEach((option: any, optIndex: number) => {
    newValues.push({
      mainid: item.question_no,
      index:  optIndex + 1,
      value: option.step_text_en || "",
  hint_id: option.hint_id || null,
  primarykeyid: option.id || ''
    });
  });
});

setValueArray(newValues);





// 2. When looping, type prev explicitly
taskData.subtasks.forEach((item: any) => {
  setSelectedmcq22((prev: Record<number, string>): Record<number, string> => ({
    ...prev,
    [item.question_no]: item.main_questions_type || "",
  }));
});









const newValues1: any[] = [];

taskData.subtasks.forEach((item: any, subIndex: number) => {
  item.hint.steps.forEach((option: any, optIndex: number) => {
    newValues1.push({
      mainid: item.question_no,
      index:  optIndex + 1,
      value: option.step_text_hi || "",
       hint_id:option.hint_id || "",
         primarykeyid: option.id || ''
    });
  });
});

setValueHiArray(newValues1);


const newValuesiamges: any[] = [];

taskData.subtasks.forEach((item: any) => {
  item.hint.steps.forEach((option: any, optIndex: number) => {
    newValuesiamges.push({
      mainId: item.question_no,
      instructionId:  optIndex + 1,
      image: option.step_icon || "",
      hint_id:option.hint_id || "",
        primarykeyid: option.id || ''
    });
  });
});

setInstructionImageMap(newValuesiamges);

const defaultCheckboxItems = taskData.subtasks.reduce(
  (acc: { [key: number]: CheckboxItem[] & { main_question_id?: number } }, item: any) => {
    if (item.main_questions_type === 'checkbox') {
      acc[item.question_no] = item.options.map((option: any, index: number) => ({
         id: index + 1,
        value: option.option_value_en || "",
        value_hi: option.option_value_hi || "",
        checked: option.correct_option === "1",
        idid: item.question_no,
        smallimage: option.option_small_img || "",
        bigimage: option.option_big_img || "",
        // main_question_id: item.question_id, // ✅ include this
      }));
    }
    return acc;
  },
  {}
);

setCheckboxItems(defaultCheckboxItems);






type DaaItem = { id: number; index: number; value: string; hint_id: string };

const daa = taskData.subtasks.reduce((acc: DaaItem[], item: any, i: number) => {
  acc.push({
    id: item.question_no,
    index: i, // incrementing index
    value: item.hint?.content_type_en || "",
    hint_id: item.hint?.hint_id || ""
  });
  return acc;
}, []);

setCorrectHintArray(daa);


const daa1 = taskData.subtasks.reduce((acc: { id: number; index: number; value: string; hint_id: string }[], item: any, i: number) => {
  acc.push({
    id: item.question_no,
    index: i, // incrementing index
    value: item.hint?.content_type_hi || "",
    hint_id: item.hint?.hint_id || ""
  });
  return acc;
}, []);

setCorrectHintHiArray(daa1);


const initialTextValueData44 = taskData.subtasks.map((item: any) => ({
  id: item.question_no,
  value: String(item.question ?? "")
}));


// Set state once
setTextValueDatadefault(initialTextValueData44);



const initialTextValueData44hindi = taskData.subtasks.map((item: any) => ({
  id: item.question_no,
  value: String(item.question_hi ?? "")
}));

setTextValueDatadefaulthindi(initialTextValueData44hindi);


taskData.subtasks.forEach((item: any) => {
  setTextValueHiData(prev => [
    ...prev,
    { id: item.question_no, value: String(item.question_hi ?? "") }
  ]);
});

        setValue(
          taskData.task_type === "Educational" || taskData.task_type === "शैक्षिक"
            ? "2"
            : taskData.task_type === "Survey Task" || taskData.task_type === "सर्वेक्षण" || taskData.task_type === "Survey"
              ? "3"
              : taskData.task_type === "Feedback Task" || taskData.task_type === "प्रतिक्रिया" || taskData.task_type === "Feedback"
                ? "4"


                : taskData.task_type === "Dotcode Scanning Task" || taskData.task_type ===  "डॉटकोड स्कैनिंग कार्य"

                ? "6"

                : taskData.task_type === "Image Capture Task"
                ? "7"

               
                : ""
        );


        if (taskData.task_icon) {
          seticonimagggg(taskData.task_icon);
          setimagesdata1([{ id: 1, images: [taskData.task_icon] }]);
        }

        // Prefill question-related data
        const subtasks = taskData.subtasks || [];

        // Set textValueData (question_en)
        setTextValueData(
          subtasks.map((subtask: any) => ({
            id: subtask.question_no,
            value: subtask.question_en || "",
          }))
        );

        // Set textValueHiData (question_hi)
        setTextValueHiData(
          subtasks.map((subtask: any) => ({
            id: subtask.question_no,
            value: subtask.question_hi || "",
          }))
        );


      } catch (error) {
        console.error("Error fetching task details:", error);
        showAlert("Failed to load task details", "error");
      }
    };

    fetchData();
  }, [
    id,
    token,

    setDurationValuetasakname,
    setDurationValuetasakname22,
    setDurationValuepoints,
    setBonusPoints,
    setDurationValue,
    setDurationUnit,
    setSelectedOptions,
    setTabname,
    duplicate_id,
    setValue,
    seticonimagggg,
    setSectionsData,
    seteducationalData,
    setimagesdata,
    setimagesdata1,
    setFiles,
    setInstructions,
    setTextValueData,
    setTextValueHiData,
    setTest22Value,
    setUploadedImages,
    setCorrectHintArray,
    setCorrectHintHiArray,
    setValueArray,
    setValueHiArray,
    setInstructionImageMap,
    setCurrentData,
  ]);

  const location = useLocation();
console.log(selectedOption1, "selectedOption13333333333333",longDescriptions,"longDescriptionslongDescriptions")
console.log(valueHiArray, "correctHintArra4455555y",valueArray)
console.log(selectedOption,"selectedOptionselectedOptionselectedOption")
const handleSubmitSave = async (
    values: Values,
    { setSubmitting }: FormikHelpers<Values>
  ) => {
    setfaltsubmit(true)

    console.log(values, "vassslues");
    const fields = [durationValue, durationValuetaskname22, durationUnit, durationValuetaskname];

    if (fields.every(f => !f)) {
      showAlert("error");
      setSubmitting(false);
      return;
    }

    if (value === "") {
      showAlert("please select one Tab");
      setSubmitting(false);
      return;
    }

    // Added validation for Approval Type
    if (selectApprovalType === "") {
      showAlert("Please select an approval type");
      setSubmitting(false);
      return;
    }

    // Filter sectionsData to remove empty text values
    const filteredSections = sectionsData.filter(
      (item) => item.textValue !== "" && item.textValue !== null
    );

    const tabNameMapEn: Record<string, string> = {
      "Availability Task": "Availability",
      "Educational task": "Educational",
      "शैक्षिक कार्य": "Educational",
      "शैक्षणिक कार्य": "Educational",
      "Survey Task": "Survey",
      "सर्वेक्षण": "Survey",
      "Feedback Task": "Feedback",
      "प्रतिक्रिया": "Feedback",
    };


    const tabNameMapHi: Record<string, string> = {
      "Availability Task": "उपलब्धता",
      "Educational task": "शैक्षिक",
      "शैक्षिक कार्य": "शैक्षिक",
      "शैक्षणिक कार्य": "शैक्षिक",
      "Survey Task": "सर्वेक्षण",
      "सर्वेक्षण": "सर्वेक्षण",
      "Feedback Task": "प्रतिक्रिया",
      "प्रतिक्रिया": "प्रतिक्रिया",
    };

    const fallbackNameEn = tabNameMapEn[Tabname] || Tabname;
    const fallbackNameHi = tabNameMapHi[Tabname] || "";
    let taskMap = {
      "Availability": { en: "Availability Task", hi: "उपलब्धता कार्य" },
      "Ranging": { en: "Ranging Task", hi: "रेंजिंग कार्य" },
      "Stock weight": { en: "Stock weight Task", hi: "स्टॉक भार कार्य" },
      "Micro Targeting": { en: "Micro Targeting Task", hi: "सूक्ष्म लक्ष्यीकरण कार्य" }
    };

    const creattask1 = {
      task_id:id?id:'',
      task_en: durationValuetaskname || "",
      task_hi: activeStep === 2
        ? (durationValuetaskname22 === "" ? durationValuetaskname : durationValuetaskname22)
        : "",
      selectedOption: taskMap[selectedOption1 as keyof typeof taskMap]?.en || "",
      selectedOption_hi: taskMap[selectedOption1 as keyof typeof taskMap]?.hi || "",

      task_discriptions: Discriptionsdata || "",
      task_discriptions_hi: activeStep === 2
        ? (Discriptionsdatahi === "" ? Discriptionsdata : Discriptionsdatahi)
        : "",
      completed_type: selectedOption === "1"
        ? "completed"
        : selectedOption === "2"
          ? "partially"
          : "",
          approval_type:
          selectApprovalType === "1"
        ? "Required"
        : selectApprovalType === "2"
          ? "Not Required"
          : "",
      credit_points: durationValuepoints,
      duration: `${durationValue || ""} ${durationUnit || ""}`.trim(),
      require_task_approval: false,
      bonus_point: bonusPoints,
      bonus_duration: `${bouncedurationValue || ""} ${bouncedurationUnit || ""
        }`.trim(),
      location: selectedOptions.length ? selectedOptions.join(",") : "",
      task_type_hi:
        activeStep === 2
          ? (
            tabsData
              .filter((item) => item.isEditable === true)
              .map((item) => item.name_hi)
              .join(",") || fallbackNameHi
          )
          : "",
      task_type_en:
        tabsData
          .filter((item) => item.isEditable === true)
          .map((item) => item.name)
          .join(",") || fallbackNameEn,
      task_icon: imagesdata1
        .filter((item) => item.images.length > 0)
        .map((item) => item.images.join(","))
        .join(","),
      intro_poster: imagesdata
        .filter((item) => item.images.length > 0)
        .flatMap((item) => item.images),

      task_instructions: instructions33.map((item) => ({
        task_instructions_id:item.id,
        task_instruction: item.value,
        task_instruction_img: item.smallimage,
        task_instruction_img_big: item.bigimage,
        task_instruction_hi: item.value_hi,
      })),

      questions: currentData.map(
        (item: {
          finalcorr: string;
          id: number;
          textValue: any;
          smallquestionsimage: any[];
          test245: any;
          Multiples: any[];
          optionsslectedvalue: any;
          instructions: {
            id: any;
            value: any;
            value_hi: any;
            smallimage: any;
          }[];
        }) => {
          const hintItemEn = correctHintArray.find(
            (hint) => hint.id === item.id
          );
          const hintItemHi = correctHintHiArray.find(
            (hint) => hint.id === item.id
          );
          //     const hintItemHi_id = correctHintHiArray.find(
          //   (hint) => hint.id === item.id
          // );
          console.log(hintItemEn, "hintItemEn889999999")
          const imageData3Item = imagesdata3.find((img) => img.id === item.id); // Match imagesdata3 by id
          const longDescriptionItem = longDescriptions[item.id]; // Match English longDescriptions by id
          const longDescriptionHiItem = longDescriptionsHi[item.id]; // Match Hi

          const textValueItem = textValueData.find((tv) => tv.id === item.id);

          const textValueItem44 = textValueData44.find((tv) => tv.id === item.id);


          const textValueHiItem = textValueHiData.find(
            (tv) => tv.id === item.id
          );


          let filteredInstructions: any[] = [];

          // if (Tabname === "Availability Task" || Tabname === "उपलब्धता") {
          filteredInstructions = item.instructions.map((int) => {
            const matchedImage = instructionImageMap.find(
              (img) => img.mainId === item.id && img.instructionId === int.id
            );

            const him = valueArray.find(
              (v) => v.mainid === item.id && v.index === int.id
            );
            const hi = valueHiArray.find(
              (v) => v.mainid === item.id && v.index === int.id
            );
            return {
              step_number: int.id,
              step_text_en: him?.value || "",
              step_text_hi: hi?.value || "",
              step_icon: matchedImage?.image || "",
              hint_id: hi?.hint_id || him?.hint_id,
              id:hi?.primarykeyid || him?.primarykeyid, 
            };
          });
          // }
          const itemStepData = step1data2.find((ii) => ii.id === item.id);


          return {
            question_en: textValueItem?.value || "",
            question_hi: textValueHiItem?.value || "",
main_questions_type: !selectedmcq22[item.id]
  ? "single answer selections"
  : selectedmcq22[item.id],
  question_id: step1data2.find(ii => ii.id === item.id)?.main_question_id || checkboxItems[item.id]?.[0]?.main_question_id,

            sample_picture: uploadedImages[item.id] || "",
            attemts: textValueItem44 ? textValueItem44.value : "",

            points: test22Value[item.id] || "",
            question_no: item.id,
           options: (() => {
  if (selectedmcq22[item.id] === "checkbox" && checkboxItems[item.id]) {
    return checkboxItems[item.id].map(check => ({
         option_id: check.id || "",
      option_big_img: check.bigimage || "",
      option_small_img: check.smallimage || "",
      option_value_en: check.value || "",
      option_value_hi: check.value_hi || "",
      checked: !!check.checked,
      question_id: check.main_question_id
    }));
  } else if (itemStepData?.Multiples) {
    return itemStepData.Multiples.map((check: {
      id: string; bigimage: any; smallimage: any; value: any; value_hi: any; 
}) => ({
        option_id: check.id || "",
      option_big_img: check.bigimage || "",
      option_small_img: check.smallimage || "",
      option_value_en: check.value || "",
      option_value_hi: check.value_hi || "",
      question_id: itemStepData.main_question_id
    }));
  }
  return [];
})(),


                correct_option: (() => {
  if (!selectedmcq22[item.id] || selectedmcq22[item.id] !== "checkbox") {
    // Single answer or other typesstep1data2
    const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
      ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
      .map((check: any) => check.value || check.value_hi);
    return matched || [];
  } else {
    // Checkbox type
    const checkedOptions = checkboxItems[item.id]
      ?.filter((check) => check.checked) // only checked ones
      .map((check) => check.value || check.value_hi);
    return checkedOptions || [];
  }
})(),

           
            // correct_option: (() => {
            //   const matched = step1data2.find(ii => ii.id === item.id)?.Multiples
            //     ?.filter((check: { ismatch: boolean }) => check.ismatch === true)
            //     .map((check: any) => check.value || check.value_hi);

            //   return matched || [];
            // })(),

            hint: {
              content_type_en: hintItemEn?.value || "",
              content_type_hi: hintItemHi?.value || "",
              hint_id:hintItemEn?.hint_id || hintItemHi?.hint_id
             
            },
            instructions: filteredInstructions,
            question_images: imageData3Item ? imageData3Item.images : [],
            long_description: longDescriptionItem || null,
            long_description_hi: longDescriptionHiItem || null,
          };
        }
      ),
    };

    console.log(creattask1, "Final task payload");

    try {
       
    let response;

if (location.pathname.startsWith("/manage-task/edit-task")) {
  response = await edittasks(creattask1, token);
} else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
  response = await duplicatetask(creattask1, token);
} else {
  response = await createtask(creattask1, token);
}
      console.log("API Responsecreatettetete:", response.data.success);
   if (response.data.success === true) {
    if (location.pathname.startsWith("/manage-task/edit-task")) {
      showAlert("Task updated successfully!", "success");
    } else if (location.pathname.startsWith("/manage-task/duplicate-task")) {
      showAlert("Task duplicated successfully!", "success");
    } else {
      showAlert("Task created successfully!", "success");
    }

    navigate("/manage-task");
  }

      setSubmitting(false);
    } catch (error: unknown) {
      setSubmitting(false);

      let errorMessage = "An error occurred while creating the task";

      if (error instanceof AxiosError) {
        // Axios error detected
        errorMessage =
          (error.response?.data as any)?.message ||
          (error.response?.data as any)?.error ||
          error.message;
      } else if (error instanceof Error) {
        // fallback for normal JS errors
        errorMessage = error.message;
      }

      console.error("Error creating task:", error);
      showAlert(errorMessage, "error");
    }
  }



  useEffect(() => {
    if (activeStep === 2 && durationValuetaskname22 === "") {
      setDurationValuetasakname22(durationValuetaskname);
    }
  }, [activeStep]);
       const displayOptions1 = options1.map(opt => {
  const labelMap: Record<string, string> = {
    Completed: "Fully Completion",
    Partially: "Partially Completion",
  };
  return { ...opt, label: labelMap[opt.label] || opt.label };
});

  return (
    <>
      <Box className="task_create" sx={{ padding: "28px 32px 0px" }}>
        <Link
          href="#"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
          Task /
          <Link
            sx={{
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "600",
              color: "rgba(142, 2, 15, 1)",
            }}
          >
            {" "}
          {id ? "Task Edit" : "Task Creation"}
          </Link>
        </Link>
        <Typography
          variant="h3"
          sx={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#000",
            marginTop: "16px",
            borderBottom: "1px solid #E7E8E9",
            paddingBottom: "24px",
            marginBottom: "24px",
          }}
        >
        {id ? "Edit Task" : "Create Task"}
        </Typography>
        <Formik
          className="formik-form"
          initialValues={{
            firstName: "grrr",
            points: durationValuepoints,
            duration: "",
            firstName_hi: "",
          }}

          validationSchema={validationSchema}
          onSubmit={handleSubmitSave}
        >
          {({ errors, touched }) => (
            <Form>
              <Box className="stepper-wrapper pb-4">
                {steps.map((step, index) => {
                  const isActive = activeStep === step.id;
                  const isCompleted = activeStep > step.id;
                  return (
                    <Box
                      key={step.id}
                      className={`stepper-item ${isActive ? "active" : ""} ${isCompleted ? "completed" : ""
                        }`}
                    >
                      <Box className="step-counter"></Box>
                      <Box
                        className="step-numbers"
                        sx={{
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "#696A6B",
                          paddingTop: "10px",

                        }}
                      >
                        Step {step.id}
                      </Box>
                      <Box
                        className="step-name"
                        sx={{
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "#282829",
                          paddingBottom: "20px",
                          paddingTop: "10px"
                        }}
                      >
                        {step.name}
                      </Box>
                    </Box>
                  );
                })}
              </Box>

              <Grid container spacing={3}>
                <Grid item md={4}>

                  {(activeStep === 1 || activeStep === 2) && (
                    <FormControl>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#282829",
                          marginBottom: "8px",
                        }}
                      >
                        {currentLang.taskName}*
                      </label>
                      <TextField
                        name="duration"
                        placeholder={currentLang.enterTaskName}
                        value={
                          activeStep === 1
                            ? durationValuetaskname
                            : durationValuetaskname22
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (activeStep === 1) {
                            setDurationValuetasakname(value);
                          } else {
                            setDurationValuetasakname22(value);
                          }
                        }}
                        type="text"
                        variant="outlined"

                        sx={{
                          minWidth: {
                            lg: '250px',
                            xl: "352px"
                          },
                          borderRadius: "10px",
                          fontSize: "16px",
                          fontWeight: 500,
                          backgroundColor: "#FFF",
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "10px",
                            '&.Mui-focused fieldset': {
                              borderColor: '#000',
                            },
                          },
                        }}
                      />
                      {activeStep === 1 && !durationValuetaskname && touched.firstName && (
                        <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
                          Please enter task name
                        </div>
                      )}
                      {activeStep === 2 && !durationValuetaskname22 && touched.firstName_hi && (
                        <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
                          Please enter task name
                        </div>
                      )}
                    </FormControl>
                  )}


                </Grid>
                <Grid item md={4} sx={{
                  minWidth: {
                    lg: '250px',
                    xl: "352px"
                  },
                }}>



                  {(activeStep === 1 || activeStep === 2) && (
                    <FormControl>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#282829",
                          marginBottom: "8px",
                        }}
                      >
                        {currentLang.taskDiscriptions}
                      </label>
                      <TextField
                        name="discription"
                        placeholder={currentLang.enterDiscrition}
                        value={
                          activeStep === 1
                            ? Discriptionsdata
                            : Discriptionsdatahi
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (activeStep === 1) {
                            setDiscriptions(value);
                          } else {
                            setDiscriptionshi(value);
                          }
                        }}
                        type="text"
                        variant="outlined"

                        sx={{
                          minWidth: {
                            lg: '250px',
                            xl: "352px"
                          },
                          borderRadius: "10px",
                          fontSize: "16px",
                          fontWeight: 500,
                          backgroundColor: "#FFF",
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "10px",
                            '&.Mui-focused fieldset': {
                              borderColor: '#000',
                            },
                          },
                          "@media (max-width: 12550px)": {
                            width: "245px",
                          },
                          "@media (max-width: 1280px)": {
                            width: "217px",
                          },
                        }}
                      />

                    </FormControl>
                  )}

                </Grid>
                <Grid item md={4}>
                  <FormControl>
                    <label
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#282829",
                        marginBottom: "8px",
                      }}
                    >
                      {currentLang.points}*
                    </label>

                    <Field name="points">
                      {({ field, form }: any) => {
                        // Ensure value is always a string
                        const value: string = String(durationValuepoints ?? "");

                        // Determine if error should show
                        const showError =
                          (form.touched.points || form.submitCount > 0) &&
                          (value.trim() === "" || /[^0-9]/.test(value));

                        // Set error message
                        let errorMessage = "";
                        if (value.trim() === "") {
                          errorMessage = "Please enter points.";
                        } else if (/[^0-9]/.test(value)) {
                          errorMessage = "Enter numbers only.";
                        }

                        return (
                          <TextField
                            {...field}
                            placeholder="Enter Total Points"
                            variant="outlined"
                            value={value} // always use safe string
                            error={showError}
                            helperText={showError ? errorMessage : ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              form.setFieldValue(field.name, val); // keep Formik in sync
                              setDurationValuepoints(val); // keep local state in sync
                            }}
                            onBlur={() => form.setFieldTouched(field.name, true)}
                            sx={{
                              borderRadius: "10px",
                              fontSize: "16px",
                              fontWeight: 500,
                              backgroundColor: "#FFF",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                "&.Mui-focused fieldset": {
                                  borderColor: "#000",
                                },
                              },
                            }}
                          />
                        );
                      }}
                    </Field>
                  </FormControl>


                </Grid>
              </Grid>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    marginTop: "28px",
                  }}
                >
                  <Box sx={{ marginBottom: "8px" }}>
                    <label
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#282829",
                        marginBottom: "8px",
                      }}
                    >
                      {currentLang.selectLocation}
                    </label>
                  </Box>
                  <ReportDropdown
                    options={options}
                    placeholder={currentLang.selectLocation}
                    value={selectedOptions}
                    onChange={handleDropdownChange}

                  />
                </Box>

                <Box sx={{
                  marginTop: "28px", 
                  marginLeft: "50px", 
                  marginBottom: "20px",
                  "@media (max-width: 1366px)": {
                    marginLeft: "90px"
                  },
                  "@media (max-width: 1280px)": {
                    marginLeft: "70px"
                  },
                }}>
                  {/* New Grid for side-by-side dropdowns */}
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}> {/* Full width on small screens, half on medium+ */}
                      <Box sx={{ marginBottom: "8px" }}>
                        <label
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#282829",
                            marginBottom: "8px",
                          }}
                        >
                          {currentLang.completedType}
                        </label>
                      </Box>
                 

                      <MultiReportDropdown
                        options={displayOptions1}
                        placeholder={currentLang.selecttype}
                        value={selectedOption}
                        onChange={handleDropdownChange1}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}> {/* Full width on small screens, half on medium+ */}
                      <Box sx={{ marginBottom: "8px" }}>
                        <label
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#282829",
                            marginBottom: "8px",
                          }}
                        >
                          {currentLang.ApprovalType}*
                        </label>
                      </Box>
                      <MultiReportDropdown
                        options={options2}
                        placeholder={currentLang.ApprovalType}
                        value={selectApprovalType}
                        onChange={handleDropdownChange2}
                      />
                    </Grid>
                  </Grid>
                </Box>
                
              </Box>
              
              {/* <AddBonus
                bouncedurationValue={bouncedurationValue}
                bouncedurationUnit={bouncedurationUnit}
                setbounceDurationValue={setbounceDurationValue}
                setbounceDurationUnit={sebouncetDurationUnit}
                bonusPoints={bonusPoints}
                setBonusPoints={setBonusPoints}
                lang={currentLang}
              /> */}
              <Box sx={{ marginTop: "20px" }}>
                <CreateType
                  //  st.ate={state} setState={setState}
                  iconImage={iconimagggg}
                  faltsubmit={faltsubmit}
                  setIconImage={seticonimagggg}
                  educationalData={educationalData}
                  Tabname33={Tabname}
                  lang={currentLang}
                  // instructions22={instructions}
                  // setInstructions={setInstructions}
                  seteducationalData={seteducationalData}
                  sectionsData={sectionsData} // ✅ Pass as props
                  setSectionsData={setSectionsData} // ✅ Pass as props
                  value={value}
                  setValue={setValue}
                  setName={setName}
                  name={name}
                  Tabname={Tabname}
                  setTabname={setTabname}
                  tabsData={tabsData}
                  setTabsData={setTabsData}
                />
              </Box>
              <Box
                sx={{
                  backgroundColor: "#FFF",
                  padding: "20px 32px 20px 44px",
                  borderTop: "1px solid #E7E8E9",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "sticky",
                  bottom: "0",
                  zIndex: "1",
                }}
              >
                <Button
                  onClick={() => {
                    if (activeStep === 2) {
                      handleBackStep(currentLang.currLang);
                    } else if (activeStep === 1) {
                      navigate('/manage-task');
                    }
                  }}
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#C8172F",
                    textTransform: "capitalize",
                    padding: "0",
                  }}
                >
                  <img style={{ marginRight: "8px" }} src={arrowleft} alt="arrowleft" />
                  Back
                </Button>
                <Box>
                  <Button
                    type="submit"
                    className="btn__save"
                    disabled={!enableSaveButton}
                    sx={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: !enableSaveButton ? "#BDBDBD" : "#FFF",
                      textTransform: "capitalize",
                      border: !enableSaveButton
                        ? "1px solid #BDBDBD"
                        : "1px solid #C8172F",
                      borderRadius: "8px",
                      padding: "10px 43px",
                      background: !enableSaveButton ? "#BDBDBD" : "#C8172F",
                      cursor: !enableSaveButton ? "not-allowed" : "pointer",
                    }}
                  >
                    Save
                  </Button>
                  {activeStep === 1 && (
                    <Button
                      onClick={() => handleNextStep(currentLang.currLang)}
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#C8172F",
                        textTransform: "capitalize",
                        border: "1px solid #C8172F",
                        borderRadius: "8px",
                        margin: "0 16px 0 28px",
                        padding: "10px 24px",
                      }}
                    >
                      Next
                    </Button>
                  )}

                  {activeStep === 2 && (
                    <Button
                      disabled
                      sx={{
                        fontSize: "14px",
                        fontWeight: "500",
                        textTransform: "capitalize",
                        border:
                          activeStep === 2
                            ? "1px solid #BDBDBD"
                            : "1px solid #C8172F",
                        borderRadius: "8px",
                        margin: "0 16px 0 28px",
                        padding: "10px 24px",
                        color: activeStep === 2 ? "#BDBDBD" : "#C8172F",
                        borderColor: activeStep === 2 ? "#E0E0E0" : "#C8172F",
                        backgroundColor:
                          activeStep === 2 ? "#BDBDBD" : "transparent",
                      }}
                    >
                      Next
                    </Button>
                  )}
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
}

export default CreateTask;